// import axios from "axios";
// import { useEffect, useState } from "react";
// import ApiUrl from "../Environment/ApiUrl";
// import { useNavigate, useParams } from "react-router-dom";
// import { useToast } from "../Toast/ToastContext";

// function UpdateLoan({ toggleSidebar }) {
//   useEffect(() => {
//     toggleSidebar();
//   }, []);

//   const { id } = useParams();
//   const navigate = useNavigate();
//   const toast = useToast();
//   // State for customer data
//   const [customerData, setCustomerData] = useState([]);

//   // Function to get current date in YYYY-MM-DD format
//   const getCurrentDate = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, "0");
//     const day = String(today.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   // Main loan data state
//   const [updateData, setUpdateData] = useState({
//     id: "",
//     customer_id: "",
//     loan_id: "",
//     loan_date: getCurrentDate(),
//     return_date: "",
//     // total_worth: "",
//     notes: "",
//     loan_amount: "",
//     created_by: "",
//     created_date: "",
//     updated_by: "",
//     updated_date: "",
//     rate_of_interest: "",
//     rate_of_value: "",
//     loan_status: "",
//     loan_close_date: "",
//     return_amount: "",
//     no_of_month: "",
//     no_of_days: "",
//     overall_total: "",
//     loan_list: [],
//   });

//   // New item form data
//   const [newItem, setNewItem] = useState({
//     loan_id: "",
//     product_name: "",
//     category: "",
//     quantity: "1",
//     weight: "",
//     amount: "",
//   });

//   // Edit item state
//   const [editingItemId, setEditingItemId] = useState(null);

//   // Fetch loan data based on ID
//   useEffect(() => {
//     const fetchLoanData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/loan.php/${id}`);
//         console.log("Loan data response:", response.data);

//         if (
//           response.data &&
//           response.data.data &&
//           response.data.data.length > 0
//         ) {
//           const loanData = response.data.data[0]; // Access the first element of the data array
//           const loanItems = loanData.loan_list || [];

//           setUpdateData({
//             id: loanData.id || "",
//             loan_id: loanData.loan_id || "",
//             loan_date: loanData.loan_date || getCurrentDate(),
//             customer_id: loanData.customer_id || "",
//             // total_worth: loanData.total_worth || "",
//             loan_amount: loanData.loan_amount || "",
//             notes: loanData.notes || "",
//             loan_list: loanItems,
//             rate_of_interest: loanData.rate_of_interest || "",
//             rate_of_value: loanData.rate_of_value || "",
//             loan_status: loanData.loan_status || "",
//             loan_close_date: loanData.loan_close_date || "",
//             return_amount: loanData.return_amount || "",
//             no_of_month: loanData.no_of_month || "",
//             no_of_days: loanData.no_of_days || "",
//             overall_total: loanData.overall_total || "",
//           });
//         }
//       } catch (error) {
//         console.error("Error fetching loan data:", error.message);
//         alert("Error loading loan data. Please try again.");
//       }
//     };

//     const fetchCustomerData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/customer.php`);
//         setCustomerData(response.data?.data || []);
//         if (id) {
//           fetchLoanData(); // Fetch loan data after customer data is loaded
//         }
//       } catch (error) {
//         console.log("Error fetching customer data:", error.message);
//         setCustomerData([]);
//       }
//     };

//     fetchCustomerData();
//   }, [id]);

//   // Handle customer change
//   const handleCustomerChange = (e) => {
//     const selectedCustomerId = e.target.value;
//     const selectedCustomer = customerData.find(
//       (customer) => customer.customer_id === selectedCustomerId
//     );

//     setUpdateData({
//       ...updateData,
//       customer_id: selectedCustomerId,
//       customer_name:
//         selectedCustomer?.name || selectedCustomer?.customer_name || "",
//       mobile: selectedCustomer?.mobile || "",
//       address: selectedCustomer?.address || "",
//     });
//   };

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setUpdateData({
//       ...updateData,
//       [name]: value,
//     });
//   };

//   // Handle new item input changes
//   const handleItemInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewItem({
//       ...newItem,
//       [name]: value,
//     });
//   };

//   // Calculate total worth from all items
//   const calculateTotalWorth = (items) => {
//     return items
//       .reduce((sum, item) => {
//         const amount = parseFloat(item.amount) || 0;
//         return sum + amount;
//       }, 0)
//       .toFixed(2);
//   };

//   // Add new item to the order
//   const handleAddItem = () => {
//     // Validate required fields
//     if (!newItem.category) {
//       alert("Please select a category");
//       return;
//     }
//     if (!newItem.product_name) {
//       alert("Please enter a product name");
//       return;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       alert("Please enter a valid quantity");
//       return;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       alert("Please enter a valid weight");
//       return;
//     }
//     if (!newItem.amount || parseFloat(newItem.amount) <= 0) {
//       alert("Please enter a valid amount");
//       return;
//     }

//     // Create new item with unique ID
//     const itemToAdd = {
//       ...newItem,
//       id: Date.now(), // Temporary ID for local management
//       loan_id: updateData.loan_id,
//     };

//     // Add new item to items array
//     const updatedItems = [...updateData.loan_list, itemToAdd];

//     // Calculate new total worth
//     const totalWorth = calculateTotalWorth(updatedItems);

//     // Update state with new item and totals
//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//       // total_worth: totalWorth,
//     });

//     // Reset new item form
//     setNewItem({
//       loan_id: updateData.loan_id,
//       product_name: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       amount: "",
//     });
//   };

//   // Edit item
//   const handleEditItem = (item) => {
//     setEditingItemId(item.id);
//     setNewItem({
//       loan_id: item.loan_id || updateData.loan_id,
//       product_name: item.product_name,
//       category: item.category,
//       quantity: item.quantity,
//       weight: item.weight,
//       amount: item.amount,
//     });
//   };

//   // Update item
//   const handleUpdateItem = () => {
//     if (editingItemId === null) return;

//     const updatedItems = updateData.loan_list.map((item) => {
//       if (item.id === editingItemId) {
//         return {
//           ...item,
//           product_name: newItem.product_name,
//           category: newItem.category,
//           quantity: newItem.quantity,
//           weight: newItem.weight,
//           amount: newItem.amount,
//         };
//       }
//       return item;
//     });

//     // Calculate new total worth
//     const totalWorth = calculateTotalWorth(updatedItems);

//     // Update state
//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//       // total_worth: totalWorth,
//     });

//     // Reset editing state
//     setEditingItemId(null);
//     setNewItem({
//       loan_id: updateData.loan_id,
//       product_name: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       amount: "",
//     });
//   };

//   // Remove item
//   const handleRemoveItem = (id) => {
//     const updatedItems = updateData.loan_list.filter((item) => item.id !== id);

//     // Calculate new total worth
//     const totalWorth = calculateTotalWorth(updatedItems);

//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//       // total_worth: totalWorth,
//     });
//   };

//   // Handle loan amount change
//   const handleLoanAmountChange = (e) => {
//     const loanAmount = e.target.value;
//     setUpdateData({
//       ...updateData,
//       loan_amount: loanAmount,
//     });
//   };

//   // Handle form submission for update
//   const handleUpdate = async () => {
//     try {
//       // Validate form
//       if (!updateData.customer_id) {
//         alert("Please select a customer");
//         return;
//       }

//       if (updateData.loan_list.length === 0) {
//         alert("Please add at least one item");
//         return;
//       }

//       if (!updateData.loan_amount) {
//         alert("Please enter loan amount");
//         return;
//       }

//       // Prepare the data to send
//       const formData = {
//         id: updateData.id,
//         customer_id: updateData.customer_id,
//         loan_id: updateData.loan_id,
//         loan_date: updateData.loan_date,
//         // total_worth: updateData.total_worth,
//         notes: updateData.notes,
//         loan_amount: updateData.loan_amount,
//         loan_list: updateData.loan_list,
//         rate_of_interest: updateData.rate_of_interest,
//         rate_of_value: updateData.rate_of_value,
//         loan_status: updateData.loan_status,
//         loan_close_date: updateData.loan_close_date,
//         return_amount: updateData.return_amount,
//         no_of_month: updateData.no_of_month,
//         no_of_days: updateData.no_of_days,
//         overall_total: updateData.overall_total,
//         updated_by: "",
//         updated_date: "",
//       };

//       console.log("Sending update data:", formData);
//       const response = await axios.put(
//         `${ApiUrl}/Api/loan.php/${id}`,
//         formData
//       );
//       console.log("Update response:", response);

//       if (response.data && response.data.success) {
//         alert("Loan updated successfully!");
//         navigate("/loan");
//         toast.success("Update successfully!", 3000, "topRight");
//       } else {
//         alert("Failed to update loan. Please try again.");
//       }
//       navigate("/loan");
//     } catch (error) {
//       console.error("Error updating loan:", error);
//       alert("Error updating loan. Please try again.");
//     }
//   };

//   return (
//     <>
//       <div className="container-fluid mb-4">
//         <div className="row g-3">
//           {/* Left Column - 4 units */}
//           <div className="col-lg-3">
//             <div className="card p-2 h-100">
//               <div className="row g-2">
//                 <div className="col-md-6">
//                   <label className="form-label">Loan No</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Loan No"
//                     value={updateData.loan_id}
//                     disabled
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Loan Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     name="loan_date"
//                     value={updateData.loan_date}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Column - 8 units */}
//           <div className="col-lg-9">
//             <div className="card h-100 p-2">
//               <div className="row g-2">
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Customer</label>
//                   <div className="input-group">
//                     <select
//                       className="form-select"
//                       onChange={handleCustomerChange}
//                       value={updateData.customer_id}
//                     >
//                       <option value="">Select Customer</option>
//                       {Array.isArray(customerData) &&
//                         customerData.map((item) => (
//                           <option
//                             key={item.customer_id}
//                             value={item.customer_id}
//                           >
//                             {item.customer_id} - {item.name}
//                           </option>
//                         ))}
//                     </select>

//                     {/* Button with dropdown */}
//                     <div className="btn-group">
//                       <button
//                         type="button"
//                         className="btn btn-outline-dark btn-sm mx-1"
//                       >
//                         <i className="bi bi-plus"></i>
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="customer_name"
//                     placeholder="Name"
//                     value={updateData.customer_name}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="mobile"
//                     value={updateData.mobile}
//                     placeholder="Mobile Number"
//                     onChange={handleInputChange}
//                   />
//                 </div>
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Address</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="address"
//                     placeholder="Address"
//                     value={updateData.address}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Order Items Section */}
//         <div className="card card-body mt-2">
//           <div className="row">
//             <div className="col-md-2">
//               <label className="form-label">Select Category</label>
//               <select
//                 className="form-select"
//                 name="category"
//                 value={newItem.category}
//                 onChange={handleItemInputChange}
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Product Name</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="Product Name"
//                 name="product_name"
//                 value={newItem.product_name}
//                 onChange={handleItemInputChange}
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Qty</label>
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 className="form-control"
//                 placeholder="Qty"
//                 name="quantity"
//                 value={newItem.quantity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Weight (g)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="(g)"
//                 name="weight"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d{0,3}$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Amount</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Amount"
//                 name="amount"
//                 value={newItem.amount}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-1">
//               {editingItemId === null ? (
//                 <button
//                   className="btn btn-success btn-sm w-100 mt-4"
//                   onClick={handleAddItem}
//                 >
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button
//                   className="btn btn-info btn-sm w-100 mt-4"
//                   onClick={handleUpdateItem}
//                 >
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>

//           <div className="row mt-2"></div>
//         </div>

//         {/* Item List and Summary Section */}
//         <div className="container-fluid mt-2">
//           <div className="row">
//             <div className="col-lg-8">
//               <div className="row">
//                 <div className="card card-body">
//                   <h6>Item List</h6>
//                   <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
//                     <div className="table-container">
//                       <table className="table table-layout-fixed w-100">
//                         <thead className="bg-light">
//                           <tr>
//                             <th>S.No</th>
//                             <th>Category</th>
//                             <th>Product</th>
//                             <th>Qty</th>
//                             <th>Weight</th>
//                             <th>Amount</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {updateData.loan_list.length > 0 ? (
//                             updateData.loan_list.map((item, index) => (
//                               <tr key={item.id || index}>
//                                 <td>{index + 1}</td>
//                                 <td>{item.category}</td>
//                                 <td>{item.product_name}</td>
//                                 <td>{item.quantity}</td>
//                                 <td>{item.weight}</td>
//                                 <td>{item.amount}</td>
//                                 <td>
//                                   <button
//                                     className="btn btn-sm btn-warning me-1"
//                                     onClick={() => handleEditItem(item)}
//                                   >
//                                     <i className="bi bi-pencil"></i>
//                                   </button>
//                                   <button
//                                     className="btn btn-sm btn-danger"
//                                     onClick={() => handleRemoveItem(item.id)}
//                                   >
//                                     <i className="bi bi-trash"></i>
//                                   </button>
//                                 </td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="7" className="text-center">
//                                 No items added yet
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mt-2">
//                 <div className="card card-body">
//                   <h6>Payment List History</h6>
//                   <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
//                     <div className="table-container">
//                       <table className="table table-layout-fixed w-100">
//                         <thead className="bg-light">
//                           <tr>
//                             <th>S.No</th>
//                             <th>Category</th>
//                             <th>Product</th>
//                             <th>Qty</th>
//                             <th>Weight</th>
//                             <th>Amount</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>



//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Form Card - Right side */}
//             <div className="col-lg-4 mb-5">
//               <div className="card card-body">
//                 {/* <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Total Worth</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.total_worth}
//                       readOnly
//                     />
//                   </div>
//                 </div> */}

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Loan Amount</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="loan_amount"
//                       value={updateData.loan_amount}
//                       onChange={(e) =>
//                         handleLoanAmountChange({
//                           target: {
//                             name: e.target.name,
//                             value: e.target.value.replace(/\D/g, ""), // Only digits
//                           },
//                         })
//                       }
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Rate Of Interest (ROI)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       name="rate_of_interest"
//                       value={updateData.rate_of_interest}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*$/.test(value)) {
//                           setUpdateData({
//                             ...updateData,
//                             rate_of_interest: value,
//                           });
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Rate Of Value (ROV)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="number"
//                       className="form-control"
//                       name="rate_of_value"
//                       value={updateData.rate_of_value}
//                       onChange={handleInputChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-lg-6">
//                     <div className="row">
//                       <div className="col-md-6">
//                         <label className="form-label">No Of Months</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           className="form-control"
//                           name="no_of_month"
//                           value={updateData.no_of_month}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*$/.test(value)) {
//                               setUpdateData({
//                                 ...updateData,
//                                 no_of_month: value,
//                               });
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="row">
//                       <div className="col-md-6">
//                         <label className="form-label">No Of Days</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           className="form-control"
//                           name="no_of_days"
//                           value={updateData.no_of_days}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*$/.test(value)) {
//                               setUpdateData({
//                                 ...updateData,
//                                 no_of_days: value,
//                               });
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Overall Total</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       name="overall_total"
//                       value={updateData.overall_total}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*$/.test(value)) {
//                           setUpdateData({
//                             ...updateData,
//                             overall_total: value,
//                           });
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Return Amount</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       name="return_amount"
//                       value={updateData.return_amount}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*$/.test(value)) {
//                           setUpdateData({
//                             ...updateData,
//                             return_amount: value,
//                           });
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Notes</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="notes"
//                       value={updateData.notes}
//                       onChange={handleInputChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Loan Status</label>
//                   </div>
//                   <div className="col-md-6">
//                     <select
//                       className="form-select"
//                       name="loan_status"
//                       value={updateData.loan_status}
//                       onChange={handleInputChange}
//                     >
//                       <option value="">Select Loan Status</option>
//                       <option value="Open">Open</option>
//                       <option value="Close">Close</option>
//                     </select>
//                   </div>
//                 </div>

//                 {updateData.loan_status === "Close" && (
//                   <div className="row mt-3">
//                     <div className="col-md-6">
//                       <label className="form-label">Loan Close Date</label>
//                     </div>
//                     <div className="col-md-6">
//                       <input
//                         type="date"
//                         className="form-control"
//                         name="loan_close_date"
//                         value={updateData.loan_close_date}
//                         onChange={handleInputChange}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 <div className="row mt-3">
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-secondary btn-sm  w-100"
//                       onClick={() => navigate("/loan")}
//                     >
//                       <i class="fa-solid fa-arrow-left"></i> Back
//                     </button>
//                   </div>
//                   {/* <div className="col-lg-3">
//                     <button
//                       className="btn btn-sm btn-warning w-100"
//                       onClick={() => navigate("/loan")}
//                     >
//                       Cancel
//                     </button>
//                   </div> */}
//                   <div className="col-lg-4">
//                     <button className="btn btn-sm btn-primary w-100">
//                       Print
//                     </button>
//                   </div>
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-sm btn-success w-100"
//                       onClick={handleUpdate}
//                     >
//                       Update
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default UpdateLoan;



// import axios from "axios";
// import { useEffect, useState } from "react";
// import ApiUrl from "../Environment/ApiUrl";
// import { useNavigate, useParams } from "react-router-dom";
// import { useToast } from "../Toast/ToastContext";

// function UpdateLoan({ toggleSidebar }) {
//   useEffect(() => {
//     toggleSidebar();
//   }, []);

//   const { id } = useParams();
//   const navigate = useNavigate();
//   const toast = useToast();
//   // State for customer data
//   const [customerData, setCustomerData] = useState([]);
//   // State for product data
//   const [productData, setProductData] = useState([]);
//   // State for modal
//   const [showModal, setShowModal] = useState(false);
//   const [generateNumber, setGenerateNumber] = useState("");
//   const [validationErrors, setValidationErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   // Function to get current date in YYYY-MM-DD format
//   const getCurrentDate = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, "0");
//     const day = String(today.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   // Main loan data state
//   const [updateData, setUpdateData] = useState({
//     id: "",
//     customer_id: "",
//     loan_id: "",
//     loan_date: getCurrentDate(),
//     return_date: "",
//     notes: "",
//     loan_amount: "",
//     created_by: "",
//     created_date: "",
//     updated_by: "",
//     updated_date: "",
//     rate_of_interest: "",
//     rate_of_value: "",
//     loan_status: "",
//     loan_close_date: "",
//     return_amount: "",
//     no_of_month: "",
//     no_of_days: "",
//     overall_total: "",
//     loan_list: [],
//     loan_payment_history: [],
//   });

//   // New item form data
//   const [newItem, setNewItem] = useState({
//     loan_id: "",
//     product_name: "",
//     category: "",
//     quantity: "1",
//     weight: "",
//     amount: "",
//   });

//   // Edit item state
//   const [editingItemId, setEditingItemId] = useState(null);

//   // Add data for new customer
//   const [addData, setAddData] = useState({
//     customer_type: "",
//     customer_id: "",
//     name: "",
//     mobile: "",
//     address: "",
//     status: "",
//     created_by: "system",
//     created_date: "",
//     updated_by: "",
//     updated_date: "",
//   });

//   // Fetch loan data based on ID
//   useEffect(() => {
//     const fetchLoanData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/loan.php/${id}`);
//         console.log("Loan data response:", response.data);

//         if (
//           response.data &&
//           response.data.data &&
//           response.data.data.length > 0
//         ) {
//           const loanData = response.data.data[0]; // Access the first element of the data array
//           const loanItems = loanData.loan_list || [];
//           const paymentHistory = loanData.loan_payment_history || [];

//           setUpdateData({
//             id: loanData.id || "",
//             loan_id: loanData.loan_id || "",
//             loan_date: loanData.loan_date || getCurrentDate(),
//             customer_id: loanData.customer_id || "",
//             loan_amount: loanData.loan_amount || "",
//             notes: loanData.notes || "",
//             loan_list: loanItems,
//             rate_of_interest: loanData.rate_of_interest || "",
//             rate_of_value: loanData.rate_of_value || "",
//             loan_status: loanData.loan_status || "",
//             loan_close_date: loanData.loan_close_date || "",
//             return_amount: loanData.return_amount || "",
//             no_of_month: loanData.no_of_month || "",
//             no_of_days: loanData.no_of_days || "",
//             overall_total: loanData.overall_total || "",
//             loan_payment_history: paymentHistory,
//           });
//         }
//       } catch (error) {
//         console.error("Error fetching loan data:", error.message);
//         alert("Error loading loan data. Please try again.");
//       }
//     };

//     const fetchCustomerData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/customer.php`);
//         setCustomerData(response.data?.data || []);
//       } catch (error) {
//         console.log("Error fetching customer data:", error.message);
//         setCustomerData([]);
//       }
//     };

//     const fetchProductData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/product.php`);
//         setProductData(response.data?.data || []);
//       } catch (error) {
//         console.log("Error fetching product data:", error.message);
//         setProductData([]);
//       }
//     };

//     fetchCustomerData();
//     fetchProductData();
//     if (id) {
//       fetchLoanData(); // Fetch loan data after customer data is loaded
//     }
//   }, [id]);

//   // Handle customer change
//   const handleCustomerChange = (e) => {
//     const selectedCustomerId = e.target.value;
//     const selectedCustomer = customerData.find(
//       (customer) => customer.customer_id === selectedCustomerId
//     );

//     setUpdateData({
//       ...updateData,
//       customer_id: selectedCustomerId,
//       customer_name:
//         selectedCustomer?.name || selectedCustomer?.customer_name || "",
//       mobile: selectedCustomer?.mobile || "",
//       address: selectedCustomer?.address || "",
//     });
//   };

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setUpdateData({
//       ...updateData,
//       [name]: value,
//     });
//   };

//   // Handle new item input changes
//   const handleItemInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewItem({
//       ...newItem,
//       [name]: value,
//     });
//   };

//   // Calculate total worth from all items
//   const calculateTotalWorth = (items) => {
//     return items
//       .reduce((sum, item) => {
//         const amount = parseFloat(item.amount) || 0;
//         return sum + amount;
//       }, 0)
//       .toFixed(2);
//   };

//   // Add new item to the order
//   const handleAddItem = () => {
//     // Validate required fields
//     if (!newItem.category) {
//       alert("Please select a category");
//       return;
//     }
//     if (!newItem.product_name) {
//       alert("Please select a product name");
//       return;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       alert("Please enter a valid quantity");
//       return;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       alert("Please enter a valid weight");
//       return;
//     }
//     if (!newItem.amount || parseFloat(newItem.amount) <= 0) {
//       alert("Please enter a valid amount");
//       return;
//     }

//     // Create new item with unique ID
//     const itemToAdd = {
//       ...newItem,
//       id: Date.now(), // Temporary ID for local management
//       loan_id: updateData.loan_id,
//     };

//     // Add new item to items array
//     const updatedItems = [...updateData.loan_list, itemToAdd];

//     // Calculate new total worth
//     const totalWorth = calculateTotalWorth(updatedItems);

//     // Update state with new item and totals
//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//     });

//     // Reset new item form
//     setNewItem({
//       loan_id: updateData.loan_id,
//       product_name: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       amount: "",
//     });
//   };

//   // Edit item
//   const handleEditItem = (item) => {
//     setEditingItemId(item.id);
//     setNewItem({
//       loan_id: item.loan_id || updateData.loan_id,
//       product_name: item.product_name,
//       category: item.category,
//       quantity: item.quantity,
//       weight: item.weight,
//       amount: item.amount,
//     });
//   };

//   // Update item
//   const handleUpdateItem = () => {
//     if (editingItemId === null) return;

//     const updatedItems = updateData.loan_list.map((item) => {
//       if (item.id === editingItemId) {
//         return {
//           ...item,
//           product_name: newItem.product_name,
//           category: newItem.category,
//           quantity: newItem.quantity,
//           weight: newItem.weight,
//           amount: newItem.amount,
//         };
//       }
//       return item;
//     });

//     // Calculate new total worth
//     const totalWorth = calculateTotalWorth(updatedItems);

//     // Update state
//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//     });

//     // Reset editing state
//     setEditingItemId(null);
//     setNewItem({
//       loan_id: updateData.loan_id,
//       product_name: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       amount: "",
//     });
//   };

//   // Remove item
//   const handleRemoveItem = (id) => {
//     const updatedItems = updateData.loan_list.filter((item) => item.id !== id);

//     // Calculate new total worth
//     const totalWorth = calculateTotalWorth(updatedItems);

//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//     });
//   };

//   // Handle loan amount change
//   const handleLoanAmountChange = (e) => {
//     const loanAmount = e.target.value;
//     setUpdateData({
//       ...updateData,
//       loan_amount: loanAmount,
//     });
//   };

//   // Handle form submission for update
//   const handleUpdate = async () => {
//     try {
//       // Validate form
//       if (!updateData.customer_id) {
//         alert("Please select a customer");
//         return;
//       }

//       if (updateData.loan_list.length === 0) {
//         alert("Please add at least one item");
//         return;
//       }

//       if (!updateData.loan_amount) {
//         alert("Please enter loan amount");
//         return;
//       }

//       // Prepare the data to send
//       const formData = {
//         id: updateData.id,
//         customer_id: updateData.customer_id,
//         loan_id: updateData.loan_id,
//         loan_date: updateData.loan_date,
//         notes: updateData.notes,
//         loan_amount: updateData.loan_amount,
//         loan_list: updateData.loan_list,
//         rate_of_interest: updateData.rate_of_interest,
//         rate_of_value: updateData.rate_of_value,
//         loan_status: updateData.loan_status,
//         loan_close_date: updateData.loan_close_date,
//         return_amount: updateData.return_amount,
//         no_of_month: updateData.no_of_month,
//         no_of_days: updateData.no_of_days,
//         overall_total: updateData.overall_total,
//         updated_by: "",
//         updated_date: "",
//       };

//       console.log("Sending update data:", formData);
//       const response = await axios.put(
//         `${ApiUrl}/Api/loan.php/${id}`,
//         formData
//       );
//       console.log("Update response:", response);

//       if (response.data && response.data.success) {
//         alert("Loan updated successfully!");
//         navigate("/loan");
//         toast.success("Update successfully!", 3000, "topRight");
//       } else {
//         alert("Failed to update loan. Please try again.");
//       }
//       navigate("/loan");
//     } catch (error) {
//       console.error("Error updating loan:", error);
//       alert("Error updating loan. Please try again.");
//     }
//   };

//   // Modal functions
//   const openModal = () => setShowModal(true);
//   const closeModal = () => {
//     setShowModal(false);
//     setValidationErrors({});
//     setAddData({
//       customer_type: "",
//       customer_id: "",
//       name: "",
//       mobile: "",
//       address: "",
//       status: "",
//       created_by: "system",
//       created_date: "",
//       updated_by: "",
//       updated_date: "",
//     });
//     setGenerateNumber("");
//   };

//   const generateCustomerId = async (customerType) => {
//     if (customerType === "Walk-In") {
//       setGenerateNumber("TJCWI-001");
//     } else {
//       try {
//         const response = await axios.get(
//           `${ApiUrl}/Api/customer.php/generate-customer-code`
//         );
//         const data = response.data?.customer_id || "";
//         setGenerateNumber(data);
//       } catch (error) {
//         console.error("Error fetching generated ID:", error.message);
//         setGenerateNumber("");
//       }
//     }
//   };

//   const handleCustomerTypeChange = (e) => {
//     const type = e.target.value;
//     setAddData({ ...addData, customer_type: type });
//     generateCustomerId(type);
//   };

//   const validateForm = (data) => {
//     let errors = {};
//     if (!data.customer_type) errors.customer_type = "Customer Type is required";
//     if (!data.name) errors.name = "Name is required";
//     if (!data.mobile || data.mobile.length !== 10) errors.mobile = "Valid 10-digit mobile number is required";
//     if (!data.status) errors.status = "Status is required";
//     setValidationErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handlesubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm(addData)) return;

//     try {
//       setLoading(true);
//       const formData = {
//         ...addData,
//         customer_id: generateNumber,
//         created_date: new Date().toISOString().slice(0, 19).replace("T", " "),
//         updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
//       };

//       const response = await axios.post(`${ApiUrl}/Api/customer.php`, formData);
//       toast.success("Added successfully!", 3000, "topRight");
//       closeModal();
//       // Refetch customer data
//       const custResponse = await axios.get(`${ApiUrl}/Api/customer.php`);
//       setCustomerData(custResponse.data?.data || []);
//     } catch (error) {
//       console.error("Error adding data:", error.message);
//       toast.error("Failed to add data", 3000, "topRight");
//     } finally {
//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//     }
//   };

//   return (
//     <>
//       <div className="container-fluid mb-4">
//         <div className="row g-3">
//           {/* Left Column - 4 units */}
//           <div className="col-lg-3">
//             <div className="card p-2 h-100">
//               <div className="row g-2">
//                 <div className="col-md-6">
//                   <label className="form-label">Loan No</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Loan No"
//                     value={updateData.loan_id}
//                     disabled
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Loan Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     name="loan_date"
//                     value={updateData.loan_date}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Column - 8 units */}
//           <div className="col-lg-9">
//             <div className="card h-100 p-2">
//               <div className="row g-2">
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Customer</label>
//                   <div className="input-group">
//                     <select
//                       className="form-select"
//                       onChange={handleCustomerChange}
//                       value={updateData.customer_id}
//                     >
//                       <option value="">Select Customer</option>
//                       {Array.isArray(customerData) &&
//                         customerData.map((item) => (
//                           <option
//                             key={item.customer_id}
//                             value={item.customer_id}
//                           >
//                             {item.customer_id} - {item.name}
//                           </option>
//                         ))}
//                     </select>

//                     {/* Button with dropdown */}
//                     <div className="btn-group">
//                       <button
//                         type="button"
//                         className="btn btn-outline-dark btn-sm mx-1"
//                         onClick={openModal}
//                       >
//                         <i className="bi bi-plus"></i>
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="customer_name"
//                     placeholder="Name"
//                     value={updateData.customer_name}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="mobile"
//                     value={updateData.mobile}
//                     placeholder="Mobile Number"
//                     onChange={handleInputChange}
//                   />
//                 </div>
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Address</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="address"
//                     placeholder="Address"
//                     value={updateData.address}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Order Items Section */}
//         <div className="card card-body mt-2">
//           <div className="row">
//             <div className="col-md-2">
//               <label className="form-label">Select Category</label>
//               <select
//                 className="form-select"
//                 name="category"
//                 value={newItem.category}
//                 onChange={handleItemInputChange}
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Product Name</label>
//               <select
//                 className="form-select"
//                 name="product_name"
//                 value={newItem.product_name}
//                 onChange={handleItemInputChange}
//               >
//                 <option value="">Select Product</option>
//                 {productData
//                   .filter((prod) => prod.category === newItem.category)
//                   .map((prod) => (
//                     <option key={prod.id} value={prod.item_name}>
//                       {prod.item_name} 
//                     </option>
//                   ))}
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Qty</label>
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 className="form-control"
//                 placeholder="Qty"
//                 name="quantity"
//                 value={newItem.quantity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Weight (g)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="(g)"
//                 name="weight"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d{0,3}$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Amount</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Amount"
//                 name="amount"
//                 value={newItem.amount}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-1">
//               {editingItemId === null ? (
//                 <button
//                   className="btn btn-success btn-sm w-100 mt-4"
//                   onClick={handleAddItem}
//                 >
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button
//                   className="btn btn-info btn-sm w-100 mt-4"
//                   onClick={handleUpdateItem}
//                 >
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>

//           <div className="row mt-2"></div>
//         </div>

//         {/* Item List and Summary Section */}
//         <div className="container-fluid mt-2">
//           <div className="row">
//             <div className="col-lg-8">
//               <div className="row">
//                 <div className="card card-body">
//                   <h6>Item List</h6>
//                   <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
//                     <div className="table-container">
//                       <table className="table table-layout-fixed w-100">
//                         <thead className="bg-light">
//                           <tr>
//                             <th>S.No</th>
//                             <th>Category</th>
//                             <th>Product</th>
//                             <th>Qty</th>
//                             <th>Weight</th>
//                             <th>Amount</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {updateData.loan_list.length > 0 ? (
//                             updateData.loan_list.map((item, index) => (
//                               <tr key={item.id || index}>
//                                 <td>{index + 1}</td>
//                                 <td>{item.category}</td>
//                                 <td>{item.product_name}</td>
//                                 <td>{item.quantity}</td>
//                                 <td>{item.weight}</td>
//                                 <td>{item.amount}</td>
//                                 <td>
//                                   <button
//                                     className="btn btn-sm btn-warning me-1"
//                                     onClick={() => handleEditItem(item)}
//                                   >
//                                     <i className="bi bi-pencil"></i>
//                                   </button>
//                                   <button
//                                     className="btn btn-sm btn-danger"
//                                     onClick={() => handleRemoveItem(item.id)}
//                                   >
//                                     <i className="bi bi-trash"></i>
//                                   </button>
//                                 </td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="7" className="text-center">
//                                 No items added yet
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mt-2">
//                 <div className="card card-body">
//                   <h6>Payment List History</h6>
//                   <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
//                     <div className="table-container">
//                       <table className="table table-layout-fixed w-100">
//                         <thead className="bg-light">
//                           <tr>
//                             <th>S.No</th>
//                             <th>Loan Id</th>
//                             <th>Payment Date</th>
//                             <th>Amount</th>
//                             <th>Payment Type</th>

//                           </tr>
//                         </thead>
//                         <tbody>
//                           {updateData.loan_payment_history.length > 0 ? (
//                             updateData.loan_payment_history.map((item, index) => (
//                               <tr key={item.id || index}>
//                                 <td>{index + 1}</td>
//                                 <td>{item.loan_id}</td>
//                                 <td>{item.payment_date}</td>
//                                 <td>{item.amount}</td>
//                                 <td>{item.payment_type}</td>

//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="5" className="text-center">
//                                 No payment history yet
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Form Card - Right side */}
//             <div className="col-lg-4 mb-5">
//               <div className="card card-body">
//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Loan Amount</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="loan_amount"
//                       value={updateData.loan_amount}
//                       onChange={(e) =>
//                         handleLoanAmountChange({
//                           target: {
//                             name: e.target.name,
//                             value: e.target.value.replace(/\D/g, ""), // Only digits
//                           },
//                         })
//                       }
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Rate Of Interest (ROI)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       name="rate_of_interest"
//                       value={updateData.rate_of_interest}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*$/.test(value)) {
//                           setUpdateData({
//                             ...updateData,
//                             rate_of_interest: value,
//                           });
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Rate Of Value (ROV)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="number"
//                       className="form-control"
//                       name="rate_of_value"
//                       value={updateData.rate_of_value}
//                       onChange={handleInputChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-lg-6">
//                     <div className="row">
//                       <div className="col-md-6">
//                         <label className="form-label">No Of Months</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           className="form-control"
//                           name="no_of_month"
//                           value={updateData.no_of_month}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*$/.test(value)) {
//                               setUpdateData({
//                                 ...updateData,
//                                 no_of_month: value,
//                               });
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="row">
//                       <div className="col-md-6">
//                         <label className="form-label">No Of Days</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           className="form-control"
//                           name="no_of_days"
//                           value={updateData.no_of_days}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*$/.test(value)) {
//                               setUpdateData({
//                                 ...updateData,
//                                 no_of_days: value,
//                               });
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Overall Total</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       name="overall_total"
//                       value={updateData.overall_total}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*$/.test(value)) {
//                           setUpdateData({
//                             ...updateData,
//                             overall_total: value,
//                           });
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Return Amount</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       name="return_amount"
//                       value={updateData.return_amount}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*$/.test(value)) {
//                           setUpdateData({
//                             ...updateData,
//                             return_amount: value,
//                           });
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Notes</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="notes"
//                       value={updateData.notes}
//                       onChange={handleInputChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="row ">
//                   <div className="col-md-6">
//                     <label className="form-label">Loan Status</label>
//                   </div>
//                   <div className="col-md-6">
//                     <select
//                       className="form-select"
//                       name="loan_status"
//                       value={updateData.loan_status}
//                       onChange={handleInputChange}
//                     >
//                       <option value="">Select Loan Status</option>
//                       <option value="Open">Open</option>
//                       <option value="Close">Close</option>
//                     </select>
//                   </div>
//                 </div>

//                 {updateData.loan_status === "Close" && (
//                   <div className="row mt-3">
//                     <div className="col-md-6">
//                       <label className="form-label">Loan Close Date</label>
//                     </div>
//                     <div className="col-md-6">
//                       <input
//                         type="date"
//                         className="form-control"
//                         name="loan_close_date"
//                         value={updateData.loan_close_date}
//                         onChange={handleInputChange}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 <div className="row mt-3">
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-secondary btn-sm  w-100"
//                       onClick={() => navigate("/loan")}
//                     >
//                       <i class="fa-solid fa-arrow-left"></i> Back
//                     </button>
//                   </div>
//                   <div className="col-lg-4">
//                     <button className="btn btn-sm btn-primary w-100">
//                       Print
//                     </button>
//                   </div>
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-sm btn-success w-100"
//                       onClick={handleUpdate}
//                     >
//                       Update
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Add Customer Modal */}
//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{
//           display: showModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="addCustomerModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6
//                 className="modal-title text-primary"
//                 id="addCustomerModalLabel"
//               >
//                 Add Customer
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={closeModal}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <form onSubmit={handlesubmit}>
//                 <div className="row">
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="customerType" className="form-label">
//                         Customer Type <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className={`form-control ${
//                           validationErrors.customer_type ? "is-invalid" : ""
//                         }`}
//                         id="customerType"
//                         value={addData.customer_type}
//                         onChange={handleCustomerTypeChange}
//                         required
//                       >
//                         <option value="" disabled>
//                           Select Customer Type
//                         </option>
//                         <option value="Walk-In">Walk-In</option>
//                         <option value="Regular">Regular</option>
//                         <option value="Retailer">Retailer</option>
//                       </select>
//                       {validationErrors.customer_type && (
//                         <div className="invalid-feedback">
//                           {validationErrors.customer_type}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="customerId" className="form-label">
//                         Customer ID
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="customerId"
//                         placeholder="Customer ID will be generated"
//                         value={generateNumber}
//                         disabled
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="name" className="form-label">
//                         Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className={`form-control ${
//                           validationErrors.name ? "is-invalid" : ""
//                         }`}
//                         id="name"
//                         placeholder="Enter Name"
//                         value={addData.name}
//                         onChange={(e) =>
//                           setAddData({ ...addData, name: e.target.value })
//                         }
//                         required
//                       />
//                       {validationErrors.name && (
//                         <div className="invalid-feedback">
//                           {validationErrors.name}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="mobile" className="form-label">
//                         Mobile Number <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         inputMode="numeric"
//                         pattern="[0-9]*"
//                         maxLength="10"
//                         className={`form-control ${
//                           validationErrors.mobile ? "is-invalid" : ""
//                         }`}
//                         id="mobile"
//                         placeholder="Enter Mobile"
//                         value={addData.mobile}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d{0,10}$/.test(value)) {
//                             setAddData({ ...addData, mobile: value });
//                           }
//                         }}
//                         required
//                       />

//                       {validationErrors.mobile && (
//                         <div className="invalid-feedback">
//                           {validationErrors.mobile}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="mb-3">
//                   <label htmlFor="address" className="form-label">
//                     Address
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="address"
//                     placeholder="Enter Address"
//                     value={addData.address}
//                     onChange={(e) =>
//                       setAddData({ ...addData, address: e.target.value })
//                     }
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label htmlFor="customerStatus" className="form-label">
//                     Status <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className={`form-select ${
//                       validationErrors.status ? "is-invalid" : ""
//                     }`}
//                     id="status"
//                     value={addData.status}
//                     onChange={(e) =>
//                       setAddData({ ...addData, status: e.target.value })
//                     }
//                     required
//                   >
//                     <option value="" disabled>
//                       Select Status
//                     </option>
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                   {validationErrors.status && (
//                     <div className="invalid-feedback">
//                       {validationErrors.status}
//                     </div>
//                   )}
//                 </div>
//                 <div className="text-center mt-4">
//                   <button
//                     type="submit"
//                     className="btn btn-primary btn-sm px-4"
//                     disabled={loading}
//                   >
//                     {loading ? "Submitting..." : "Submit"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default UpdateLoan;




// import axios from "axios";
// import { useEffect, useState } from "react";
// import ApiUrl from "../Environment/ApiUrl";
// import { useNavigate, useParams } from "react-router-dom";
// import { useToast } from "../Toast/ToastContext";

// function UpdateLoan({ toggleSidebar }) {
//   useEffect(() => {
//     toggleSidebar();
//   }, []);

//   const { id } = useParams();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const [customerData, setCustomerData] = useState([]);
//   const [productData, setProductData] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [generateNumber, setGenerateNumber] = useState("");
//   const [validationErrors, setValidationErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const getCurrentDate = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, "0");
//     const day = String(today.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   const [updateData, setUpdateData] = useState({
//     id: "",
//     customer_id: "",
//     loan_id: "",
//     loan_date: getCurrentDate(),
//     return_date: "",
//     notes: "",
//     loan_amount: "",
//     created_by: "",
//     created_date: "",
//     updated_by: "",
//     updated_date: "",
//     rate_of_interest: "",
//     rate_of_value: "",
//     loan_status: "",
//     loan_close_date: "",
//     return_amount: "",
//     no_of_month: "",
//     no_of_days: "",
//     overall_total: "",
//     loan_list: [],
//     loan_payment_history: [],
//   });

//   const [newItem, setNewItem] = useState({
//     loan_id: "",
//     product_name: "",
//     category: "",
//     quantity: "1",
//     weight: "",
//     amount: "",
//   });

//   const [editingItemId, setEditingItemId] = useState(null);

//   const [addData, setAddData] = useState({
//     customer_type: "",
//     customer_id: "",
//     name: "",
//     mobile: "",
//     address: "",
//     status: "",
//     created_by: "system",
//     created_date: "",
//     updated_by: "",
//     updated_date: "",
//   });

//   // Calculate ROV, Overall Total, and Return Amount
//   const calculateLoanMetrics = (loanAmount, roi, months, days) => {
//     const principal = parseFloat(loanAmount) || 0;
//     const rate = parseFloat(roi) || 0;
//     const monthsValue = parseFloat(months) || 0;
//     const daysValue = parseFloat(days) || 0;

//     // Calculate Rate of Value (ROV) using simple interest
//     // ROV = Principal * Rate * Time (where Time = months/12 + days/365)
//     const timeInYears = monthsValue / 12 + daysValue / 365;
//     const rov = (principal * rate * timeInYears) / 100;

//     // Overall Total = Loan Amount + ROV
//     const overallTotal = principal + rov;

//     // Return Amount = Overall Total (assuming this is the total amount to be returned)
//     const returnAmount = overallTotal;

//     return {
//       rate_of_value: rov.toFixed(2),
//       overall_total: overallTotal.toFixed(2),
//       return_amount: returnAmount.toFixed(2),
//     };
//   };

//   // Update calculations when relevant fields change
//   useEffect(() => {
//     const { loan_amount, rate_of_interest, no_of_month, no_of_days } = updateData;
//     const metrics = calculateLoanMetrics(
//       loan_amount,
//       rate_of_interest,
//       no_of_month,
//       no_of_days
//     );
//     setUpdateData((prev) => ({
//       ...prev,
//       rate_of_value: metrics.rate_of_value,
//       overall_total: metrics.overall_total,
//       return_amount: metrics.return_amount,
//     }));
//   }, [
//     updateData.loan_amount,
//     updateData.rate_of_interest,
//     updateData.no_of_month,
//     updateData.no_of_days,
//   ]);

//   useEffect(() => {
//     const fetchLoanData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/loan.php/${id}`);
//         console.log("Loan data response:", response.data);

//         if (
//           response.data &&
//           response.data.data &&
//           response.data.data.length > 0
//         ) {
//           const loanData = response.data.data[0];
//           const loanItems = loanData.loan_list || [];
//           const paymentHistory = loanData.loan_payment_history || [];

//           setUpdateData({
//             id: loanData.id || "",
//             loan_id: loanData.loan_id || "",
//             loan_date: loanData.loan_date || getCurrentDate(),
//             customer_id: loanData.customer_id || "",
//             loan_amount: loanData.loan_amount || "",
//             notes: loanData.notes || "",
//             loan_list: loanItems,
//             rate_of_interest: loanData.rate_of_interest || "",
//             rate_of_value: loanData.rate_of_value || "",
//             loan_status: loanData.loan_status || "",
//             loan_close_date: loanData.loan_close_date || "",
//             return_amount: loanData.return_amount || "",
//             no_of_month: loanData.no_of_month || "",
//             no_of_days: loanData.no_of_days || "",
//             overall_total: loanData.overall_total || "",
//             loan_payment_history: paymentHistory,
//           });
//         }
//       } catch (error) {
//         console.error("Error fetching loan data:", error.message);
//         alert("Error loading loan data. Please try again.");
//       }
//     };

//     const fetchCustomerData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/customer.php`);
//         setCustomerData(response.data?.data || []);
//       } catch (error) {
//         console.log("Error fetching customer data:", error.message);
//         setCustomerData([]);
//       }
//     };

//     const fetchProductData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/product.php`);
//         setProductData(response.data?.data || []);
//       } catch (error) {
//         console.log("Error fetching product data:", error.message);
//         setProductData([]);
//       }
//     };

//     fetchCustomerData();
//     fetchProductData();
//     if (id) {
//       fetchLoanData();
//     }
//   }, [id]);

//   const handleCustomerChange = (e) => {
//     const selectedCustomerId = e.target.value;
//     const selectedCustomer = customerData.find(
//       (customer) => customer.customer_id === selectedCustomerId
//     );

//     setUpdateData({
//       ...updateData,
//       customer_id: selectedCustomerId,
//       customer_name:
//         selectedCustomer?.name || selectedCustomer?.customer_name || "",
//       mobile: selectedCustomer?.mobile || "",
//       address: selectedCustomer?.address || "",
//     });
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setUpdateData({
//       ...updateData,
//       [name]: value,
//     });
//   };

//   const handleItemInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewItem({
//       ...newItem,
//       [name]: value,
//     });
//   };

//   const calculateTotalWorth = (items) => {
//     return items
//       .reduce((sum, item) => {
//         const amount = parseFloat(item.amount) || 0;
//         return sum + amount;
//       }, 0)
//       .toFixed(2);
//   };

//   const handleAddItem = () => {
//     if (!newItem.category) {
//       alert("Please select a category");
//       return;
//     }
//     if (!newItem.product_name) {
//       alert("Please select a product name");
//       return;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       alert("Please enter a valid quantity");
//       return;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       alert("Please enter a valid weight");
//       return;
//     }
//     if (!newItem.amount || parseFloat(newItem.amount) <= 0) {
//       alert("Please enter a valid amount");
//       return;
//     }

//     const itemToAdd = {
//       ...newItem,
//       id: Date.now(),
//       loan_id: updateData.loan_id,
//     };

//     const updatedItems = [...updateData.loan_list, itemToAdd];

//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//     });

//     setNewItem({
//       loan_id: updateData.loan_id,
//       product_name: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       amount: "",
//     });
//   };

//   const handleEditItem = (item) => {
//     setEditingItemId(item.id);
//     setNewItem({
//       loan_id: item.loan_id || updateData.loan_id,
//       product_name: item.product_name,
//       category: item.category,
//       quantity: item.quantity,
//       weight: item.weight,
//       amount: item.amount,
//     });
//   };

//   const handleUpdateItem = () => {
//     if (editingItemId === null) return;

//     const updatedItems = updateData.loan_list.map((item) => {
//       if (item.id === editingItemId) {
//         return {
//           ...item,
//           product_name: newItem.product_name,
//           category: newItem.category,
//           quantity: newItem.quantity,
//           weight: newItem.weight,
//           amount: newItem.amount,
//         };
//       }
//       return item;
//     });

//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//     });

//     setEditingItemId(null);
//     setNewItem({
//       loan_id: updateData.loan_id,
//       product_name: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       amount: "",
//     });
//   };

//   const handleRemoveItem = (id) => {
//     const updatedItems = updateData.loan_list.filter((item) => item.id !== id);
//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//     });
//   };

//   const handleLoanAmountChange = (e) => {
//     const loanAmount = e.target.value.replace(/\D/g, "");
//     setUpdateData({
//       ...updateData,
//       loan_amount: loanAmount,
//     });
//   };

//   const handleUpdate = async () => {
//     try {
//       if (!updateData.customer_id) {
//         alert("Please select a customer");
//         return;
//       }

//       if (updateData.loan_list.length === 0) {
//         alert("Please add at least one item");
//         return;
//       }

//       if (!updateData.loan_amount) {
//         alert("Please enter loan amount");
//         return;
//       }

//       const formData = {
//         id: updateData.id,
//         customer_id: updateData.customer_id,
//         loan_id: updateData.loan_id,
//         loan_date: updateData.loan_date,
//         notes: updateData.notes,
//         loan_amount: updateData.loan_amount,
//         loan_list: updateData.loan_list,
//         rate_of_interest: updateData.rate_of_interest,
//         rate_of_value: updateData.rate_of_value,
//         loan_status: updateData.loan_status,
//         loan_close_date: updateData.loan_close_date,
//         return_amount: updateData.return_amount,
//         no_of_month: updateData.no_of_month,
//         no_of_days: updateData.no_of_days,
//         overall_total: updateData.overall_total,
//         updated_by: "",
//         updated_date: "",
//       };

//       console.log("Sending update data:", formData);
//       const response = await axios.put(
//         `${ApiUrl}/Api/loan.php/${id}`,
//         formData
//       );
//       console.log("Update response:", response);

//       if (response.data && response.data.success) {
//         alert("Loan updated successfully!");
//         navigate("/loan");
//         toast.success("Update successfully!", 3000, "topRight");
//       }
//       navigate("/loan");
//     } catch (error) {
//       console.error("Error updating loan:", error);
//       alert("Error updating loan. Please try again.");
//     }
//   };

//   const openModal = () => setShowModal(true);
//   const closeModal = () => {
//     setShowModal(false);
//     setValidationErrors({});
//     setAddData({
//       customer_type: "",
//       customer_id: "",
//       name: "",
//       mobile: "",
//       address: "",
//       status: "",
//       created_by: "system",
//       created_date: "",
//       updated_by: "",
//       updated_date: "",
//     });
//     setGenerateNumber("");
//   };

//   const generateCustomerId = async (customerType) => {
//     if (customerType === "Walk-In") {
//       setGenerateNumber("TJCWI-001");
//     } else {
//       try {
//         const response = await axios.get(
//           `${ApiUrl}/Api/customer.php/generate-customer-code`
//         );
//         const data = response.data?.customer_id || "";
//         setGenerateNumber(data);
//       } catch (error) {
//         console.error("Error fetching generated ID:", error.message);
//         setGenerateNumber("");
//       }
//     }
//   };

//   const handleCustomerTypeChange = (e) => {
//     const type = e.target.value;
//     setAddData({ ...addData, customer_type: type });
//     generateCustomerId(type);
//   };

//   const validateForm = (data) => {
//     let errors = {};
//     if (!data.customer_type) errors.customer_type = "Customer Type is required";
//     if (!data.name) errors.name = "Name is required";
//     if (!data.mobile || data.mobile.length !== 10) errors.mobile = "Valid 10-digit mobile number is required";
//     if (!data.status) errors.status = "Status is required";
//     setValidationErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handlesubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm(addData)) return;

//     try {
//       setLoading(true);
//       const formData = {
//         ...addData,
//         customer_id: generateNumber,
//         created_date: new Date().toISOString().slice(0, 19).replace("T", " "),
//         updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
//       };

//       const response = await axios.post(`${ApiUrl}/Api/customer.php`, formData);
//       toast.success("Added successfully!", 3000, "topRight");
//       closeModal();
//       const custResponse = await axios.get(`${ApiUrl}/Api/customer.php`);
//       setCustomerData(custResponse.data?.data || []);
//     } catch (error) {
//       console.error("Error adding data:", error.message);
//       toast.error("Failed to add data", 3000, "topRight");
//     } finally {
//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//     }
//   };

//   return (
//     <>
//       <div className="container-fluid mb-4">
//         <div className="row g-3">
//           <div className="col-lg-3">
//             <div className="card p-2 h-100">
//               <div className="row g-2">
//                 <div className="col-md-6">
//                   <label className="form-label">Loan No</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Loan No"
//                     value={updateData.loan_id}
//                     disabled
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Loan Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     name="loan_date"
//                     value={updateData.loan_date}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-9">
//             <div className="card h-100 p-2">
//               <div className="row g-2">
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Customer</label>
//                   <div className="input-group">
//                     <select
//                       className="form-select"
//                       onChange={handleCustomerChange}
//                       value={updateData.customer_id}
//                     >
//                       <option value="">Select Customer</option>
//                       {Array.isArray(customerData) &&
//                         customerData.map((item) => (
//                           <option
//                             key={item.customer_id}
//                             value={item.customer_id}
//                           >
//                             {item.customer_id} - {item.name}
//                           </option>
//                         ))}
//                     </select>
//                     <div className="btn-group">
//                       <button
//                         type="button"
//                         className="btn btn-outline-dark btn-sm mx-1"
//                         onClick={openModal}
//                       >
//                         <i className="bi bi-plus"></i>
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="customer_name"
//                     placeholder="Name"
//                     value={updateData.customer_name}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="mobile"
//                     value={updateData.mobile}
//                     placeholder="Mobile Number"
//                     onChange={handleInputChange}
//                   />
//                 </div>
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Address</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="address"
//                     placeholder="Address"
//                     value={updateData.address}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="card card-body mt-2">
//           <div className="row">
//             <div className="col-md-2">
//               <label className="form-label">Select Category</label>
//               <select
//                 className="form-select"
//                 name="category"
//                 value={newItem.category}
//                 onChange={handleItemInputChange}
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Product Name</label>
//               <select
//                 className="form-select"
//                 name="product_name"
//                 value={newItem.product_name}
//                 onChange={handleItemInputChange}
//               >
//                 <option value="">Select Product</option>
//                 {productData
//                   .filter((prod) => prod.category === newItem.category)
//                   .map((prod) => (
//                     <option key={prod.id} value={prod.item_name}>
//                       {prod.item_name}
//                     </option>
//                   ))}
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Qty</label>
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 className="form-control"
//                 placeholder="Qty"
//                 name="quantity"
//                 value={newItem.quantity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Weight (g)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="(g)"
//                 name="weight"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d{0,3}$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Amount</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Amount"
//                 name="amount"
//                 value={newItem.amount}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-1">
//               {editingItemId === null ? (
//                 <button
//                   className="btn btn-success btn-sm w-100 mt-4"
//                   onClick={handleAddItem}
//                 >
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button
//                   className="btn btn-info btn-sm w-100 mt-4"
//                   onClick={handleUpdateItem}
//                 >
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="container-fluid mt-2">
//           <div className="row">
//             <div className="col-lg-8">
//               <div className="row">
//                 <div className="card card-body">
//                   <h6>Item List</h6>
//                   <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
//                     <div className="table-container">
//                       <table className="table table-layout-fixed w-100">
//                         <thead className="bg-light">
//                           <tr>
//                             <th>S.No</th>
//                             <th>Category</th>
//                             <th>Product</th>
//                             <th>Qty</th>
//                             <th>Weight</th>
//                             <th>Amount</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {updateData.loan_list.length > 0 ? (
//                             updateData.loan_list.map((item, index) => (
//                               <tr key={item.id || index}>
//                                 <td>{index + 1}</td>
//                                 <td>{item.category}</td>
//                                 <td>{item.product_name}</td>
//                                 <td>{item.quantity}</td>
//                                 <td>{item.weight}</td>
//                                 <td>{item.amount}</td>
//                                 <td>
//                                   <button
//                                     className="btn btn-sm btn-warning me-1"
//                                     onClick={() => handleEditItem(item)}
//                                   >
//                                     <i className="bi bi-pencil"></i>
//                                   </button>
//                                   <button
//                                     className="btn btn-sm btn-danger"
//                                     onClick={() => handleRemoveItem(item.id)}
//                                   >
//                                     <i className="bi bi-trash"></i>
//                                   </button>
//                                 </td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="7" className="text-center">
//                                 No items added yet
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mt-2">
//                 <div className="card card-body">
//                   <h6>Payment List History</h6>
//                   <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
//                     <div className="table-container">
//                       <table className="table table-layout-fixed w-100">
//                         <thead className="bg-light">
//                           <tr>
//                             <th>S.No</th>
//                             <th>Loan Id</th>
//                             <th>Payment Date</th>
//                             <th>Amount</th>
//                             <th>Payment Type</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {updateData.loan_payment_history.length > 0 ? (
//                             updateData.loan_payment_history.map((item, index) => (
//                               <tr key={item.id || index}>
//                                 <td>{index + 1}</td>
//                                 <td>{item.loan_id}</td>
//                                 <td>{item.payment_date}</td>
//                                 <td>{item.amount}</td>
//                                 <td>{item.payment_type}</td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="5" className="text-center">
//                                 No payment history yet
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-lg-4 mb-5">
//               <div className="card card-body">
//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Loan Amount</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       name="loan_amount"
//                       value={updateData.loan_amount}
//                       onChange={handleLoanAmountChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Rate Of Interest (ROI)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="decimal"
//                       className="form-control"
//                       name="rate_of_interest"
//                       value={updateData.rate_of_interest}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           setUpdateData({
//                             ...updateData,
//                             rate_of_interest: value,
//                           });
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>


//                 <div className="row mt-3">
//                   <div className="col-lg-6">
//                     <div className="row">
//                       <div className="col-md-6">
//                         <label className="form-label">No Of Months</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           className="form-control"
//                           name="no_of_month"
//                           value={updateData.no_of_month}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*$/.test(value)) {
//                               setUpdateData({
//                                 ...updateData,
//                                 no_of_month: value,
//                               });
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="row">
//                       <div className="col-md-6">
//                         <label className="form-label">No Of Days</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           className="form-control"
//                           name="no_of_days"
//                           value={updateData.no_of_days}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*$/.test(value)) {
//                               setUpdateData({
//                                 ...updateData,
//                                 no_of_days: value,
//                               });
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>


//                   <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Rate Of Value (ROV)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="rate_of_value"
//                       value={updateData.rate_of_value}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Overall Total</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="overall_total"
//                       value={updateData.overall_total}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Return Amount</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="return_amount"
//                       value={updateData.return_amount}

//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Notes</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="notes"
//                       value={updateData.notes}
//                       onChange={handleInputChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Loan Status</label>
//                   </div>
//                   <div className="col-md-6">
//                     <select
//                       className="form-select"
//                       name="loan_status"
//                       value={updateData.loan_status}
//                       onChange={handleInputChange}
//                     >
//                       <option value="">Select Loan Status</option>
//                       <option value="Open">Open</option>
//                       <option value="Close">Close</option>
//                     </select>
//                   </div>
//                 </div>

//                 {updateData.loan_status === "Close" && (
//                   <div className="row mt-3">
//                     <div className="col-md-6">
//                       <label className="form-label">Loan Close Date</label>
//                     </div>
//                     <div className="col-md-6">
//                       <input
//                         type="date"
//                         className="form-control"
//                         name="loan_close_date"
//                         value={updateData.loan_close_date}
//                         onChange={handleInputChange}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 <div className="row mt-3">
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-secondary btn-sm w-100"
//                       onClick={() => navigate("/loan")}
//                     >
//                       <i className="fa-solid fa-arrow-left"></i> Back
//                     </button>
//                   </div>
//                   <div className="col-lg-4">
//                     <button className="btn btn-sm btn-primary w-100">
//                       Print
//                     </button>
//                   </div>
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-sm btn-success w-100"
//                       onClick={handleUpdate}
//                     >
//                       Update
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{
//           display: showModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="addCustomerModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6
//                 className="modal-title text-primary"
//                 id="addCustomerModalLabel"
//               >
//                 Add Customer
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={closeModal}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <form onSubmit={handlesubmit}>
//                 <div className="row">
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="customerType" className="form-label">
//                         Customer Type <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className={`form-control ${
//                           validationErrors.customer_type ? "is-invalid" : ""
//                         }`}
//                         id="customerType"
//                         value={addData.customer_type}
//                         onChange={handleCustomerTypeChange}
//                         required
//                       >
//                         <option value="" disabled>
//                           Select Customer Type
//                         </option>
//                         <option value="Walk-In">Walk-In</option>
//                         <option value="Regular">Regular</option>
//                         <option value="Retailer">Retailer</option>
//                       </select>
//                       {validationErrors.customer_type && (
//                         <div className="invalid-feedback">
//                           {validationErrors.customer_type}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="customerId" className="form-label">
//                         Customer ID
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="customerId"
//                         placeholder="Customer ID will be generated"
//                         value={generateNumber}
//                         disabled
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="name" className="form-label">
//                         Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className={`form-control ${
//                           validationErrors.name ? "is-invalid" : ""
//                         }`}
//                         id="name"
//                         placeholder="Enter Name"
//                         value={addData.name}
//                         onChange={(e) =>
//                           setAddData({ ...addData, name: e.target.value })
//                         }
//                         required
//                       />
//                       {validationErrors.name && (
//                         <div className="invalid-feedback">
//                           {validationErrors.name}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="mobile" className="form-label">
//                         Mobile Number <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         inputMode="numeric"
//                         pattern="[0-9]*"
//                         maxLength="10"
//                         className={`form-control ${
//                           validationErrors.mobile ? "is-invalid" : ""
//                         }`}
//                         id="mobile"
//                         placeholder="Enter Mobile"
//                         value={addData.mobile}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d{0,10}$/.test(value)) {
//                             setAddData({ ...addData, mobile: value });
//                           }
//                         }}
//                         required
//                       />
//                       {validationErrors.mobile && (
//                         <div className="invalid-feedback">
//                           {validationErrors.mobile}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="mb-3">
//                   <label htmlFor="address" className="form-label">
//                     Address
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="address"
//                     placeholder="Enter Address"
//                     value={addData.address}
//                     onChange={(e) =>
//                       setAddData({ ...addData, address: e.target.value })
//                     }
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label htmlFor="customerStatus" className="form-label">
//                     Status <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className={`form-select ${
//                       validationErrors.status ? "is-invalid" : ""
//                     }`}
//                     id="status"
//                     value={addData.status}
//                     onChange={(e) =>
//                       setAddData({ ...addData, status: e.target.value })
//                     }
//                     required
//                   >
//                     <option value="" disabled>
//                       Select Status
//                     </option>
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                   {validationErrors.status && (
//                     <div className="invalid-feedback">
//                       {validationErrors.status}
//                     </div>
//                   )}
//                 </div>
//                 <div className="text-center mt-4">
//                   <button
//                     type="submit"
//                     className="btn btn-primary btn-sm px-4"
//                     disabled={loading}
//                   >
//                     {loading ? "Submitting..." : "Submit"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default UpdateLoan;


// import axios from "axios";
// import { useEffect, useState } from "react";
// import ApiUrl from "../Environment/ApiUrl";
// import { useNavigate, useParams } from "react-router-dom";
// import { useToast } from "../Toast/ToastContext";

// function UpdateLoan({ toggleSidebar }) {
//   useEffect(() => {
//     toggleSidebar();
//   }, []);

//   const { id } = useParams();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const [customerData, setCustomerData] = useState([]);
//   const [productData, setProductData] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [generateNumber, setGenerateNumber] = useState("");
//   const [validationErrors, setValidationErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const getCurrentDate = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, "0");
//     const day = String(today.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   const [updateData, setUpdateData] = useState({
//     id: "",
//     customer_id: "",
//     loan_id: "",
//     loan_date: getCurrentDate(),
//     return_date: "",
//     notes: "",
//     loan_amount: "",
//     created_by: "",
//     created_date: "",
//     updated_by: "",
//     updated_date: "",
//     rate_of_interest: "",
//     rate_of_value: "",
//     loan_status: "",
//     loan_close_date: "",
//     return_amount: "",
//     no_of_month: "",
//     no_of_days: "",
//     overall_total: "",
//     loan_list: [],
//     loan_payment_history: [],
//   });

//   const [newItem, setNewItem] = useState({
//     loan_id: "",
//     product_name: "",
//     category: "",
//     quantity: "1",
//     weight: "",
//     amount: "",
//   });

//   const [editingItemId, setEditingItemId] = useState(null);

//   const [addData, setAddData] = useState({
//     customer_type: "",
//     customer_id: "",
//     name: "",
//     mobile: "",
//     address: "",
//     status: "",
//     created_by: "system",
//     created_date: "",
//     updated_by: "",
//     updated_date: "",
//   });

//   // Calculate ROV and Overall Total
//   const calculateLoanMetrics = (loanAmount, roi, months, days) => {
//     const principal = parseFloat(loanAmount) || 0;
//     const rate = parseFloat(roi) || 0;
//     const monthsValue = parseFloat(months) || 0;
//     const daysValue = parseFloat(days) || 0;

//     // Calculate Rate of Value (ROV) using simple interest
//     // ROV = Principal * Rate * Time (where Time = months/12 + days/365)
//     const timeInYears = monthsValue / 12 + daysValue / 365;
//     const rov = (principal * rate * timeInYears) / 100;

//     // Overall Total = Loan Amount + ROV
//     const overallTotal = principal + rov;

//     return {
//       rate_of_value: rov.toFixed(2),
//       overall_total: overallTotal.toFixed(2),
//     };
//   };

//   // Update calculations when relevant fields change
//   useEffect(() => {
//     const { loan_amount, rate_of_interest, no_of_month, no_of_days } = updateData;
//     const metrics = calculateLoanMetrics(
//       loan_amount,
//       rate_of_interest,
//       no_of_month,
//       no_of_days
//     );
//     setUpdateData((prev) => ({
//       ...prev,
//       rate_of_value: metrics.rate_of_value,
//       overall_total: metrics.overall_total,
//     }));
//   }, [
//     updateData.loan_amount,
//     updateData.rate_of_interest,
//     updateData.no_of_month,
//     updateData.no_of_days,
//   ]);

//   useEffect(() => {
//     const fetchLoanData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/loan.php/${id}`);
//         console.log("Loan data response:", response.data);

//         if (
//           response.data &&
//           response.data.data &&
//           response.data.data.length > 0
//         ) {
//           const loanData = response.data.data[0];
//           const loanItems = loanData.loan_list || [];
//           const paymentHistory = loanData.loan_payment_history || [];

//           setUpdateData({
//             id: loanData.id || "",
//             loan_id: loanData.loan_id || "",
//             loan_date: loanData.loan_date || getCurrentDate(),
//             customer_id: loanData.customer_id || "",
//             loan_amount: loanData.loan_amount || "",
//             notes: loanData.notes || "",
//             loan_list: loanItems,
//             rate_of_interest: loanData.rate_of_interest || "",
//             rate_of_value: loanData.rate_of_value || "",
//             loan_status: loanData.loan_status || "",
//             loan_close_date: loanData.loan_close_date || "",
//             return_amount: loanData.return_amount || "",
//             no_of_month: loanData.no_of_month || "",
//             no_of_days: loanData.no_of_days || "",
//             overall_total: loanData.overall_total || "",
//             loan_payment_history: paymentHistory,
//           });
//         }
//       } catch (error) {
//         console.error("Error fetching loan data:", error.message);
//         alert("Error loading loan data. Please try again.");
//       }
//     };

//     const fetchCustomerData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/customer.php`);
//         setCustomerData(response.data?.data || []);
//       } catch (error) {
//         console.log("Error fetching customer data:", error.message);
//         setCustomerData([]);
//       }
//     };

//     const fetchProductData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/product.php`);
//         setProductData(response.data?.data || []);
//       } catch (error) {
//         console.log("Error fetching product data:", error.message);
//         setProductData([]);
//       }
//     };

//     fetchCustomerData();
//     fetchProductData();
//     if (id) {
//       fetchLoanData();
//     }
//   }, [id]);

//   const handleCustomerChange = (e) => {
//     const selectedCustomerId = e.target.value;
//     const selectedCustomer = customerData.find(
//       (customer) => customer.customer_id === selectedCustomerId
//     );

//     setUpdateData({
//       ...updateData,
//       customer_id: selectedCustomerId,
//       customer_name:
//         selectedCustomer?.name || selectedCustomer?.customer_name || "",
//       mobile: selectedCustomer?.mobile || "",
//       address: selectedCustomer?.address || "",
//     });
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setUpdateData({
//       ...updateData,
//       [name]: value,
//     });
//   };

//   const handleItemInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewItem({
//       ...newItem,
//       [name]: value,
//     });
//   };

//   const calculateTotalWorth = (items) => {
//     return items
//       .reduce((sum, item) => {
//         const amount = parseFloat(item.amount) || 0;
//         return sum + amount;
//       }, 0)
//       .toFixed(2);
//   };

//   const handleAddItem = () => {
//     if (!newItem.category) {
//       alert("Please select a category");
//       return;
//     }
//     if (!newItem.product_name) {
//       alert("Please select a product name");
//       return;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       alert("Please enter a valid quantity");
//       return;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       alert("Please enter a valid weight");
//       return;
//     }
//     if (!newItem.amount || parseFloat(newItem.amount) <= 0) {
//       alert("Please enter a valid amount");
//       return;
//     }

//     const itemToAdd = {
//       ...newItem,
//       id: Date.now(),
//       loan_id: updateData.loan_id,
//     };

//     const updatedItems = [...updateData.loan_list, itemToAdd];

//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//     });

//     setNewItem({
//       loan_id: updateData.loan_id,
//       product_name: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       amount: "",
//     });
//   };

//   const handleEditItem = (item) => {
//     setEditingItemId(item.id);
//     setNewItem({
//       loan_id: item.loan_id || updateData.loan_id,
//       product_name: item.product_name,
//       category: item.category,
//       quantity: item.quantity,
//       weight: item.weight,
//       amount: item.amount,
//     });
//   };

//   const handleUpdateItem = () => {
//     if (editingItemId === null) return;

//     const updatedItems = updateData.loan_list.map((item) => {
//       if (item.id === editingItemId) {
//         return {
//           ...item,
//           product_name: newItem.product_name,
//           category: newItem.category,
//           quantity: newItem.quantity,
//           weight: newItem.weight,
//           amount: newItem.amount,
//         };
//       }
//       return item;
//     });

//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//     });

//     setEditingItemId(null);
//     setNewItem({
//       loan_id: updateData.loan_id,
//       product_name: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       amount: "",
//     });
//   };

//   const handleRemoveItem = (id) => {
//     const updatedItems = updateData.loan_list.filter((item) => item.id !== id);
//     setUpdateData({
//       ...updateData,
//       loan_list: updatedItems,
//     });
//   };

//   const handleLoanAmountChange = (e) => {
//     const loanAmount = e.target.value.replace(/\D/g, "");
//     setUpdateData({
//       ...updateData,
//       loan_amount: loanAmount,
//     });
//   };

//   const handleUpdate = async () => {
//     try {
//       if (!updateData.customer_id) {
//         alert("Please select a customer");
//         return;
//       }

//       if (updateData.loan_list.length === 0) {
//         alert("Please add at least one item");
//         return;
//       }

//       if (!updateData.loan_amount) {
//         alert("Please enter loan amount");
//         return;
//       }

//       const formData = {
//         id: updateData.id,
//         customer_id: updateData.customer_id,
//         loan_id: updateData.loan_id,
//         loan_date: updateData.loan_date,
//         notes: updateData.notes,
//         loan_amount: updateData.loan_amount,
//         loan_list: updateData.loan_list,
//         rate_of_interest: updateData.rate_of_interest,
//         rate_of_value: updateData.rate_of_value,
//         loan_status: updateData.loan_status,
//         loan_close_date: updateData.loan_close_date,
//         return_amount: updateData.return_amount,
//         no_of_month: updateData.no_of_month,
//         no_of_days: updateData.no_of_days,
//         overall_total: updateData.overall_total,
//         updated_by: "",
//         updated_date: "",
//       };

//       console.log("Sending update data:", formData);
//       const response = await axios.put(
//         `${ApiUrl}/Api/loan.php/${id}`,
//         formData
//       );
//       console.log("Update response:", response);

//       if (response.data && response.data.success) {
//         alert("Loan updated successfully!");
//         navigate("/loan");
//         toast.success("Update successfully!", 3000, "topRight");
//       }
//       navigate("/loan");
//     } catch (error) {
//       console.error("Error updating loan:", error);
//       alert("Error updating loan. Please try again.");
//     }
//   };

//   const openModal = () => setShowModal(true);
//   const closeModal = () => {
//     setShowModal(false);
//     setValidationErrors({});
//     setAddData({
//       customer_type: "",
//       customer_id: "",
//       name: "",
//       mobile: "",
//       address: "",
//       status: "",
//       created_by: "system",
//       created_date: "",
//       updated_by: "",
//       updated_date: "",
//     });
//     setGenerateNumber("");
//   };

//   const generateCustomerId = async (customerType) => {
//     if (customerType === "Walk-In") {
//       setGenerateNumber("TJCWI-001");
//     } else {
//       try {
//         const response = await axios.get(
//           `${ApiUrl}/Api/customer.php/generate-customer-code`
//         );
//         const data = response.data?.customer_id || "";
//         setGenerateNumber(data);
//       } catch (error) {
//         console.error("Error fetching generated ID:", error.message);
//         setGenerateNumber("");
//       }
//     }
//   };

//   const handleCustomerTypeChange = (e) => {
//     const type = e.target.value;
//     setAddData({ ...addData, customer_type: type });
//     generateCustomerId(type);
//   };

//   const validateForm = (data) => {
//     let errors = {};
//     if (!data.customer_type) errors.customer_type = "Customer Type is required";
//     if (!data.name) errors.name = "Name is required";
//     if (!data.mobile || data.mobile.length !== 10) errors.mobile = "Valid 10-digit mobile number is required";
//     if (!data.status) errors.status = "Status is required";
//     setValidationErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handlesubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm(addData)) return;

//     try {
//       setLoading(true);
//       const formData = {
//         ...addData,
//         customer_id: generateNumber,
//         created_date: new Date().toISOString().slice(0, 19).replace("T", " "),
//         updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
//       };

//       const response = await axios.post(`${ApiUrl}/Api/customer.php`, formData);
//       toast.success("Added successfully!", 3000, "topRight");
//       closeModal();
//       const custResponse = await axios.get(`${ApiUrl}/Api/customer.php`);
//       setCustomerData(custResponse.data?.data || []);
//     } catch (error) {
//       console.error("Error adding data:", error.message);
//       toast.error("Failed to add data", 3000, "topRight");
//     } finally {
//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//     }
//   };

//   const handlePrint = () => {
//     navigate(`/loan/${updateData.loan_id}`);
//   };

//   return (
//     <>
//       <div className="container-fluid mb-4">
//         <div className="row g-3">
//           <div className="col-lg-3">
//             <div className="card p-2 h-100">
//               <div className="row g-2">
//                 <div className="col-md-6">
//                   <label className="form-label">Loan No</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Loan No"
//                     value={updateData.loan_id}
//                     disabled
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Loan Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     name="loan_date"
//                     value={updateData.loan_date}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-9">
//             <div className="card h-100 p-2">
//               <div className="row g-2">
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Customer</label>
//                   <div className="input-group">
//                     <select
//                       className="form-select"
//                       onChange={handleCustomerChange}
//                       value={updateData.customer_id}
//                     >
//                       <option value="">Select Customer</option>
//                       {Array.isArray(customerData) &&
//                         customerData.map((item) => (
//                           <option
//                             key={item.customer_id}
//                             value={item.customer_id}
//                           >
//                             {item.customer_id} - {item.name}
//                           </option>
//                         ))}
//                     </select>
//                     <div className="btn-group">
//                       <button
//                         type="button"
//                         className="btn btn-outline-dark btn-sm mx-1"
//                         onClick={openModal}
//                       >
//                         <i className="bi bi-plus"></i>
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="customer_name"
//                     placeholder="Name"
//                     value={updateData.customer_name}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="mobile"
//                     value={updateData.mobile}
//                     placeholder="Mobile Number"
//                     onChange={handleInputChange}
//                   />
//                 </div>
//                 <div className="col-sm-6 col-md-3">
//                   <label className="form-label">Address</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="address"
//                     placeholder="Address"
//                     value={updateData.address}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="card card-body mt-2">
//           <div className="row">
//             <div className="col-md-2">
//               <label className="form-label">Select Category</label>
//               <select
//                 className="form-select"
//                 name="category"
//                 value={newItem.category}
//                 onChange={handleItemInputChange}
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Product Name</label>
//               <select
//                 className="form-select"
//                 name="product_name"
//                 value={newItem.product_name}
//                 onChange={handleItemInputChange}
//               >
//                 <option value="">Select Product</option>
//                 {productData
//                   .filter((prod) => prod.category === newItem.category)
//                   .map((prod) => (
//                     <option key={prod.id} value={prod.item_name}>
//                       {prod.item_name}
//                     </option>
//                   ))}
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Qty</label>
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 className="form-control"
//                 placeholder="Qty"
//                 name="quantity"
//                 value={newItem.quantity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Weight (g)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="(g)"
//                 name="weight"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d{0,3}$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Amount</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Amount"
//                 name="amount"
//                 value={newItem.amount}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-1">
//               {editingItemId === null ? (
//                 <button
//                   className="btn btn-success btn-sm w-100 mt-4"
//                   onClick={handleAddItem}
//                 >
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button
//                   className="btn btn-info btn-sm w-100 mt-4"
//                   onClick={handleUpdateItem}
//                 >
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="container-fluid mt-2">
//           <div className="row">
//             <div className="col-lg-8">
//               <div className="row">
//                 <div className="card card-body">
//                   <h6>Item List</h6>
//                   <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
//                     <div className="table-container">
//                       <table className="table table-layout-fixed w-100">
//                         <thead className="bg-light">
//                           <tr>
//                             <th>S.No</th>
//                             <th>Category</th>
//                             <th>Product</th>
//                             <th>Qty</th>
//                             <th>Weight</th>
//                             <th>Amount</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {updateData.loan_list.length > 0 ? (
//                             updateData.loan_list.map((item, index) => (
//                               <tr key={item.id || index}>
//                                 <td>{index + 1}</td>
//                                 <td>{item.category}</td>
//                                 <td>{item.product_name}</td>
//                                 <td>{item.quantity}</td>
//                                 <td>{item.weight}</td>
//                                 <td>{item.amount}</td>
//                                 <td>
//                                   <button
//                                     className="btn btn-sm btn-warning me-1"
//                                     onClick={() => handleEditItem(item)}
//                                   >
//                                     <i className="bi bi-pencil"></i>
//                                   </button>
//                                   <button
//                                     className="btn btn-sm btn-danger"
//                                     onClick={() => handleRemoveItem(item.id)}
//                                   >
//                                     <i className="bi bi-trash"></i>
//                                   </button>
//                                 </td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="7" className="text-center">
//                                 No items added yet
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="row mt-2">
//                 <div className="card card-body">
//                   <h6>Payment List History</h6>
//                   <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
//                     <div className="table-container">
//                       <table className="table table-layout-fixed w-100">
//                         <thead className="bg-light">
//                           <tr>
//                             <th>S.No</th>
//                             <th>Loan Id</th>
//                             <th>Payment Date</th>
//                             <th>Amount</th>
//                             <th>Payment Type</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {updateData.loan_payment_history.length > 0 ? (
//                             updateData.loan_payment_history.map((item, index) => (
//                               <tr key={item.id || index}>
//                                 <td>{index + 1}</td>
//                                 <td>{item.loan_id}</td>
//                                 <td>{item.payment_date}</td>
//                                 <td>{item.amount}</td>
//                                 <td>{item.payment_type}</td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="5" className="text-center">
//                                 No payment history yet
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-lg-4 mb-5">
//               <div className="card card-body">
//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Loan Amount</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       className="form-control"
//                       name="loan_amount"
//                       value={updateData.loan_amount}
//                       onChange={handleLoanAmountChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Rate Of Interest (ROI)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="decimal"
//                       className="form-control"
//                       name="rate_of_interest"
//                       value={updateData.rate_of_interest}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           setUpdateData({
//                             ...updateData,
//                             rate_of_interest: value,
//                           });
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>


//                 <div className="row mt-3">
//                   <div className="col-lg-6">
//                     <div className="row">
//                       <div className="col-md-6">
//                         <label className="form-label">No Of Months</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           className="form-control"
//                           name="no_of_month"
//                           value={updateData.no_of_month}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*$/.test(value)) {
//                               setUpdateData({
//                                 ...updateData,
//                                 no_of_month: value,
//                               });
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="row">
//                       <div className="col-md-6">
//                         <label className="form-label">No Of Days</label>
//                       </div>
//                       <div className="col-md-6">
//                         <input
//                           type="text"
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           className="form-control"
//                           name="no_of_days"
//                           value={updateData.no_of_days}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             if (/^\d*$/.test(value)) {
//                               setUpdateData({
//                                 ...updateData,
//                                 no_of_days: value,
//                               });
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>


//                 <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Rate Of Value (ROV)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="rate_of_value"
//                       value={updateData.rate_of_value}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Overall Total</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="overall_total"
//                       value={updateData.overall_total}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Return Amount</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="return_amount"
//                       value={updateData.return_amount}
//                       onChange={handleInputChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Notes</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="notes"
//                       value={updateData.notes}
//                       onChange={handleInputChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Loan Status</label>
//                   </div>
//                   <div className="col-md-6">
//                     <select
//                       className="form-select"
//                       name="loan_status"
//                       value={updateData.loan_status}
//                       onChange={handleInputChange}
//                     >
//                       <option value="">Select Loan Status</option>
//                       <option value="Open">Open</option>
//                       <option value="Close">Close</option>
//                     </select>
//                   </div>
//                 </div>

//                 {updateData.loan_status === "Close" && (
//                   <div className="row mt-3">
//                     <div className="col-md-6">
//                       <label className="form-label">Loan Close Date</label>
//                     </div>
//                     <div className="col-md-6">
//                       <input
//                         type="date"
//                         className="form-control"
//                         name="loan_close_date"
//                         value={updateData.loan_close_date}
//                         onChange={handleInputChange}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 <div className="row mt-3">
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-secondary btn-sm w-100"
//                       onClick={() => navigate("/loan")}
//                     >
//                       <i className="fa-solid fa-arrow-left"></i> Back
//                     </button>
//                   </div>
//                   <div className="col-lg-4">
//                     <button 
//                       className="btn btn-sm btn-primary w-100"
//                       onClick={handlePrint}
//                     >
//                       Print
//                     </button>
//                   </div>
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-sm btn-success w-100"
//                       onClick={handleUpdate}
//                     >
//                       Update
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{
//           display: showModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="addCustomerModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6
//                 className="modal-title text-primary"
//                 id="addCustomerModalLabel"
//               >
//                 Add Customer
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={closeModal}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <form onSubmit={handlesubmit}>
//                 <div className="row">
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="customerType" className="form-label">
//                         Customer Type <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className={`form-control ${
//                           validationErrors.customer_type ? "is-invalid" : ""
//                         }`}
//                         id="customerType"
//                         value={addData.customer_type}
//                         onChange={handleCustomerTypeChange}
//                         required
//                       >
//                         <option value="" disabled>
//                           Select Customer Type
//                         </option>
//                         <option value="Walk-In">Walk-In</option>
//                         <option value="Regular">Regular</option>
//                         <option value="Retailer">Retailer</option>
//                       </select>
//                       {validationErrors.customer_type && (
//                         <div className="invalid-feedback">
//                           {validationErrors.customer_type}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="customerId" className="form-label">
//                         Customer ID
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="customerId"
//                         placeholder="Customer ID will be generated"
//                         value={generateNumber}
//                         disabled
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="name" className="form-label">
//                         Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className={`form-control ${
//                           validationErrors.name ? "is-invalid" : ""
//                         }`}
//                         id="name"
//                         placeholder="Enter Name"
//                         value={addData.name}
//                         onChange={(e) =>
//                           setAddData({ ...addData, name: e.target.value })
//                         }
//                         required
//                       />
//                       {validationErrors.name && (
//                         <div className="invalid-feedback">
//                           {validationErrors.name}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div className="mb-3">
//                       <label htmlFor="mobile" className="form-label">
//                         Mobile Number <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         inputMode="numeric"
//                         pattern="[0-9]*"
//                         maxLength="10"
//                         className={`form-control ${
//                           validationErrors.mobile ? "is-invalid" : ""
//                         }`}
//                         id="mobile"
//                         placeholder="Enter Mobile"
//                         value={addData.mobile}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d{0,10}$/.test(value)) {
//                             setAddData({ ...addData, mobile: value });
//                           }
//                         }}
//                         required
//                       />
//                       {validationErrors.mobile && (
//                         <div className="invalid-feedback">
//                           {validationErrors.mobile}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="mb-3">
//                   <label htmlFor="address" className="form-label">
//                     Address
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="address"
//                     placeholder="Enter Address"
//                     value={addData.address}
//                     onChange={(e) =>
//                       setAddData({ ...addData, address: e.target.value })
//                     }
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label htmlFor="customerStatus" className="form-label">
//                     Status <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className={`form-select ${
//                       validationErrors.status ? "is-invalid" : ""
//                     }`}
//                     id="status"
//                     value={addData.status}
//                     onChange={(e) =>
//                       setAddData({ ...addData, status: e.target.value })
//                     }
//                     required
//                   >
//                     <option value="" disabled>
//                       Select Status
//                     </option>
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                   {validationErrors.status && (
//                     <div className="invalid-feedback">
//                       {validationErrors.status}
//                     </div>
//                   )}
//                 </div>
//                 <div className="text-center mt-4">
//                   <button
//                     type="submit"
//                     className="btn btn-primary btn-sm px-4"
//                     disabled={loading}
//                   >
//                     {loading ? "Submitting..." : "Submit"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default UpdateLoan;




import axios from "axios";
import { useEffect, useState } from "react";
import ApiUrl from "../Environment/ApiUrl";
import { useNavigate, useParams } from "react-router-dom";
import { useToast } from "../Toast/ToastContext";

function UpdateLoan({ toggleSidebar }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [showModal, setShowModal] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [generateNumber, setGenerateNumber] = useState("");
  const [customerData, setCustomerData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [actionType, setActionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [isManualProductInput, setIsManualProductInput] = useState(false);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Initialize updateData state
  const [updateData, setUpdateData] = useState({
    id: "",
    loan_id: "",
    loan_date: getCurrentDate(),
    customer_id: "",
    customer_name: "",
    mobile: "",
    address: "",
    loan_amount: "",
    notes: "",
    loan_list: [],
    created_by: "system",
    created_date: "",
    rate_of_interest: "",
    rate_of_value: "",
    loan_status: "",
    loan_close_date: "",
    return_amount: "",
    no_of_month: "",
    no_of_days: "",
    overall_total: "",
    loan_payment_history: [],
  });

  // Initialize newItem
  const [newItem, setNewItem] = useState({
    loan_id: "",
    product_name: "",
    category: "",
    quantity: "1",
    weight: "",
    amount: "",
  });

  const [addCustomerData, setAddCustomerData] = useState({
    customer_type: "",
    customer_id: "",
    name: "",
    mobile: "",
    address: "",
    status: "",
    created_by: "system",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });

  const [editingItemId, setEditingItemId] = useState(null);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const openCustomerModal = () => setShowCustomerModal(true);
  const closeCustomerModal = () => {
    setShowCustomerModal(false);
    setActionType("");
    setAddCustomerData({
      customer_type: "",
      customer_id: "",
      name: "",
      mobile: "",
      address: "",
      status: "",
      created_by: "system",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
    setValidationErrors({});
  };

  const handlePrint = () => {
    navigate(`/loan/${updateData.loan_id}`);
  };

  const fetchCustomerData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/customer.php`);
      setCustomerData(response.data?.data || []);
      return response.data?.data || [];
    } catch (error) {
      console.log("Error fetching customer data:", error.message);
      setCustomerData([]);
      return [];
    }
  };

  const fetchProductData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/product.php`);
      setProductData(response.data?.data || []);
    } catch (error) {
      console.log("Error fetching product data:", error.message);
      setProductData([]);
    }
  };

  // Single useEffect to fetch all data
  useEffect(() => {
    toggleSidebar();
    
    const fetchAllData = async () => {
      try {
        // First fetch customer data
        const customers = await fetchCustomerData();
        
        // Fetch product data
        await fetchProductData();
        
        // Then fetch loan data
        if (id) {
          const loanResponse = await axios.get(`${ApiUrl}/Api/loan.php/${id}`);
          if (loanResponse.data && loanResponse.data.data && loanResponse.data.data.length > 0) {
            const loanData = loanResponse.data.data[0];
            const loanItems = (loanData.loan_list || []).map((item) => ({
              ...item,
              id: item.id || Date.now().toString(),
            }));
            const paymentHistory = loanData.loan_payment_history || [];
            
            // Find customer details from fetched customer data
            const selectedCustomer = customers.find(
              (customer) => customer.customer_id === loanData.customer_id
            );
            
            setUpdateData({
              id: loanData.id || "",
              loan_id: loanData.loan_id || "",
              loan_date: loanData.loan_date || getCurrentDate(),
              customer_id: loanData.customer_id || "",
              customer_name: selectedCustomer?.name || "",
              mobile: selectedCustomer?.mobile || "",
              address: selectedCustomer?.address || "",
              loan_amount: loanData.loan_amount || "",
              notes: loanData.notes || "",
              loan_list: loanItems,
              created_by: loanData.created_by || "system",
              created_date: loanData.created_date || "",
              rate_of_interest: loanData.rate_of_interest || "",
              rate_of_value: loanData.rate_of_value || "",
              loan_status: loanData.loan_status || "",
              loan_close_date: loanData.loan_close_date || "",
              return_amount: loanData.return_amount || "",
              no_of_month: loanData.no_of_month || "",
              no_of_days: loanData.no_of_days || "",
              overall_total: loanData.overall_total || "",
              loan_payment_history: paymentHistory,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
        toast.error("Error loading data. Please try again.", 3000, "topRight");
      }
    };
    
    fetchAllData();
  }, [id]); // Only dependency is id

  useEffect(() => {
    setNewItem((prevItem) => ({
      ...prevItem,
      loan_id: updateData.loan_id,
    }));
  }, [updateData.loan_id]);

  const generateCustomerId = async (customerType) => {
    if (customerType === "Walk-In") {
      setAddCustomerData((prev) => ({ ...prev, customer_id: "TJCWI-001" }));
    } else {
      try {
        const response = await axios.get(
          `${ApiUrl}/Api/customer.php/generate-customer-code`
        );
        setAddCustomerData((prev) => ({
          ...prev,
          customer_id: response.data?.customer_id || "",
        }));
      } catch (error) {
        console.error("Error fetching generated ID:", error.message);
        setAddCustomerData((prev) => ({ ...prev, customer_id: "" }));
      }
    }
  };

  const handleCustomerChange = (e) => {
    const selectedCustomerId = e.target.value;
    const selectedCustomer = customerData.find(
      (customer) => customer.customer_id === selectedCustomerId
    );

    if (selectedCustomer) {
      setUpdateData({
        ...updateData,
        customer_id: selectedCustomer.customer_id,
        customer_name: selectedCustomer.name || "",
        mobile: selectedCustomer.mobile || "",
        address: selectedCustomer.address || "",
      });
    } else {
      setUpdateData({
        ...updateData,
        customer_id: "",
        customer_name: "",
        mobile: "",
        address: "",
      });
    }
  };

  const handleCustomerTypeChange = (e) => {
    const customerType = e.target.value;
    setAddCustomerData({ ...addCustomerData, customer_type: customerType });
    generateCustomerId(customerType);
  };

  const handleItemInputChange = (e) => {
    const { name, value } = e.target;
    setNewItem({
      ...newItem,
      [name]: value,
    });
  };

  const calculateTotalWorth = (items) => {
    const total = items.reduce((sum, item) => {
      const amount = parseFloat(item.amount) || 0;
      return sum + amount;
    }, 0);
    return total.toFixed(2);
  };

  // Calculate ROV and Overall Total
  const calculateLoanMetrics = (loanAmount, roi, months, days) => {
    const principal = parseFloat(loanAmount) || 0;
    const rate = parseFloat(roi) || 0;
    const monthsValue = parseFloat(months) || 0;
    const daysValue = parseFloat(days) || 0;

    const timeInYears = monthsValue / 12 + daysValue / 365;
    const rov = (principal * rate * timeInYears) / 100;
    const overallTotal = principal + rov;

    return {
      rate_of_value: rov.toFixed(2),
      overall_total: overallTotal.toFixed(2),
    };
  };

  useEffect(() => {
    const totalWorth = calculateTotalWorth(updateData.loan_list);
    const { loan_amount, rate_of_interest, no_of_month, no_of_days } = updateData;
    const metrics = calculateLoanMetrics(
      totalWorth,
      rate_of_interest,
      no_of_month,
      no_of_days
    );
    setUpdateData((prevData) => ({
      ...prevData,
      loan_amount: totalWorth,
      rate_of_value: metrics.rate_of_value,
      overall_total: metrics.overall_total,
    }));
  }, [
    updateData.loan_list,
    updateData.rate_of_interest,
    updateData.no_of_month,
    updateData.no_of_days,
  ]);

  const handleAddItem = () => {
    if (!newItem.category) {
      alert("Please select a category");
      return;
    }
    if (!newItem.product_name) {
      alert("Please enter/select a product name");
      return;
    }
    if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
      alert("Please enter a valid quantity");
      return;
    }
    if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
      alert("Please enter a valid weight");
      return;
    }
    if (!newItem.amount || parseFloat(newItem.amount) <= 0) {
      alert("Please enter a valid amount");
      return;
    }

    const itemToAdd = {
      ...newItem,
      id: Date.now().toString(),
      loan_id: updateData.loan_id,
    };

    const updatedItems = [...updateData.loan_list, itemToAdd];

    setUpdateData({
      ...updateData,
      loan_list: updatedItems,
    });

    setNewItem({
      loan_id: updateData.loan_id,
      product_name: "",
      category: "",
      quantity: "1",
      weight: "",
      amount: "",
    });

    setIsManualProductInput(false);
  };

  const handleEditItem = (item) => {
    setEditingItemId(item.id);
    setNewItem({
      loan_id: item.loan_id || updateData.loan_id,
      product_name: item.product_name,
      category: item.category,
      quantity: item.quantity,
      weight: item.weight,
      amount: item.amount,
    });
    const isInList = productData.some(
      (product) => product.item_name === item.product_name
    );
    setIsManualProductInput(!isInList);
  };

  const handleUpdateItem = () => {
    if (editingItemId === null) return;

    const updatedItems = updateData.loan_list.map((item) => {
      if (item.id === editingItemId) {
        return {
          ...item,
          loan_id: updateData.loan_id,
          product_name: newItem.product_name,
          category: newItem.category,
          quantity: newItem.quantity,
          weight: newItem.weight,
          amount: newItem.amount,
        };
      }
      return item;
    });

    setUpdateData({
      ...updateData,
      loan_list: updatedItems,
    });

    setEditingItemId(null);
    setNewItem({
      loan_id: updateData.loan_id,
      product_name: "",
      category: "",
      quantity: "1",
      weight: "",
      amount: "",
    });
    setIsManualProductInput(false);
  };

  const handleRemoveItem = (id) => {
    const updatedItems = updateData.loan_list.filter((item) => item.id !== id);
    setUpdateData({
      ...updateData,
      loan_list: updatedItems,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "rate_of_interest" || name === "no_of_month" || name === "no_of_days") {
      if (/^\d*\.?\d*$/.test(value) || value === "") {
        setUpdateData({
          ...updateData,
          [name]: value,
        });
      }
    } else if (name === "return_amount") {
      if (/^\d*\.?\d*$/.test(value) || value === "") {
        setUpdateData({
          ...updateData,
          [name]: value,
        });
      }
    } else if (name === "loan_status" && value === "Close") {
      setUpdateData({
        ...updateData,
        loan_status: value,
        loan_close_date: getCurrentDate(),
      });
    } else {
      setUpdateData({
        ...updateData,
        [name]: value,
      });
    }
  };

  const validateCustomerForm = (data) => {
    const errors = {};
    if (!data.customer_type) errors.customer_type = "Customer type is required";
    if (!data.name) errors.name = "Name is required";
    if (!data.mobile || !/^\d{10}$/.test(data.mobile))
      errors.mobile = "Valid 10-digit mobile number is required";
    if (!data.status) errors.status = "Status is required";
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleCustomerSubmit = async (e) => {
    e.preventDefault();
    if (!validateCustomerForm(addCustomerData)) return;

    try {
      setLoading(true);
      const formData = {
        ...addCustomerData,
        created_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
      };

      await axios.post(`${ApiUrl}/Api/customer.php`, formData);
      toast.success("Customer added successfully!", 3000, "topRight");
      await fetchCustomerData();
      setUpdateData({
        ...updateData,
        customer_id: addCustomerData.customer_id,
        customer_name: addCustomerData.name,
        mobile: addCustomerData.mobile,
        address: addCustomerData.address,
      });
      closeCustomerModal();
    } catch (error) {
      console.error("Error adding customer:", error.message);
      toast.error("Failed to add customer", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  const toggleProductInputMode = () => {
    setIsManualProductInput(!isManualProductInput);
    if (!isManualProductInput) {
      setNewItem({ ...newItem, product_name: "" });
    }
  };

  const handleLoanSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      if (!updateData.customer_id) {
        alert("Please select a customer");
        return;
      }
      if (updateData.loan_list.length === 0) {
        alert("Please add at least one item");
        return;
      }
      if (!updateData.loan_amount || parseFloat(updateData.loan_amount) <= 0) {
        alert("Please ensure a valid loan amount");
        return;
      }

      const formData = {
        id: updateData.id,
        loan_id: updateData.loan_id,
        loan_date: updateData.loan_date,
        customer_id: updateData.customer_id,
        loan_amount: updateData.loan_amount,
        notes: updateData.notes,
        loan_list: updateData.loan_list,
        created_by: updateData.created_by,
        created_date: updateData.created_date || new Date().toISOString().slice(0, 19).replace("T", " "),
        rate_of_interest: updateData.rate_of_interest,
        rate_of_value: updateData.rate_of_value,
        loan_status: updateData.loan_status,
        loan_close_date: updateData.loan_close_date,
        return_amount: updateData.return_amount,
        no_of_month: updateData.no_of_month,
        no_of_days: updateData.no_of_days,
        overall_total: updateData.overall_total,
        updated_by: "system",
        updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
      };

      const response = await axios.put(`${ApiUrl}/Api/loan.php/${id}`, formData);

      if (response.data.status) {
        toast.success("Loan updated successfully!", 3000, "topRight");
        navigate("/loan");
      } else {
        toast.error(
          response.data.message || "Failed to update loan data",
          3000,
          "topRight"
        );
      }
    } catch (error) {
      console.error("Error updating loan:", error);
      toast.error("Error updating loan. Please try again.", 3000, "topRight");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate("/loan");
  };

  const filteredProducts = productData.filter(
    (product) => product.category === newItem.category
  );

  return (
    <>
      <div className="container-fluid position-relative py-2">
        <div className="row g-3">
          <div className="col-lg-3">
            <div className="card p-2">
              <div className="row g-2">
                <div className="col-md-6">
                  <label className="form-label">Loan ID</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Loan No"
                    value={updateData.loan_id}
                    disabled
                    readOnly
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Loan Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="loan_date"
                    value={updateData.loan_date}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-9">
            <div className="card h-100 p-2">
              <div className="row g-2">
                <div className="col-sm-6 col-md-3">
                  <label className="form-label">Customer</label>
                  <div className="input-group">
                    <select
                      className="form-select"
                      onChange={handleCustomerChange}
                      value={updateData.customer_id}
                      disabled
                    >
                      <option value="">Select Customer</option>
                      {Array.isArray(customerData) &&
                        customerData.map((item) => (
                          <option
                            key={item.customer_id}
                            value={item.customer_id}
                          >
                            {item.customer_id} - {item.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6 col-md-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="customer_name"
                    placeholder="Name"
                    value={updateData.customer_name || ""}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div className="col-sm-6 col-md-3">
                  <label className="form-label">Mobile Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    value={updateData.mobile || ""}
                    placeholder="Mobile Number"
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div className="col-sm-6 col-md-3">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    placeholder="Address"
                    value={updateData.address || ""}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card card-body mt-2">
          <div className="row">
            <div className="col-md-2">
              <label className="form-label">Select Category</label>
              <select
                className="form-select"
                name="category"
                value={newItem.category}
                onChange={handleItemInputChange}
              >
                <option value="">Select Category</option>
                <option value="Gold">Gold</option>
                <option value="Silver">Silver</option>
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label">Product Name</label>
              <div className="d-flex align-items-center">
                {isManualProductInput ? (
                  <input
                    type="text"
                    className="form-control me-2"
                    name="product_name"
                    value={newItem.product_name}
                    onChange={handleItemInputChange}
                    disabled={!newItem.category}
                    placeholder="Enter product name"
                  />
                ) : (
                  <select
                    className="form-select me-2"
                    name="product_name"
                    value={newItem.product_name}
                    onChange={handleItemInputChange}
                    disabled={!newItem.category}
                  >
                    <option value="">Select Product</option>
                    {filteredProducts.length > 0 ? (
                      filteredProducts.map((product) => (
                        <option key={product.id} value={product.item_name}>
  {product.item_name}{product.item_name_tamil ? ` / ${product.item_name_tamil}` : ""}
</option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No products available
                      </option>
                    )}
                  </select>
                )}
                {/* <button
                  type="button"
                  className="btn btn-outline-dark btn-sm"
                  onClick={toggleProductInputMode}
                  title={
                    isManualProductInput ? "Select from list" : "Enter manually"
                  }
                >
                  <i
                    className={`bi ${isManualProductInput ? "bi-x" : "bi-plus"
                      }`}
                  ></i>
                </button> */}
              </div>
            </div>

            <div className="col-md-2">
              <label className="form-label">Qty</label>
              <input
                type="text"
                inputMode="numeric"
                className="form-control"
                placeholder="Qty"
                name="quantity"
                value={newItem.quantity}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    handleItemInputChange(e);
                  }
                }}
              />
            </div>

            <div className="col-md-2">
              <label className="form-label">Weight (g)</label>
              <input
                type="text"
                inputMode="decimal"
                className="form-control"
                placeholder="(g)"
                name="weight"
                value={newItem.weight}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d{0,3}$/.test(value)) {
                    handleItemInputChange(e);
                  }
                }}
              />
            </div>

            <div className="col-md-2">
              <label className="form-label">Amount (₹)</label>
              <input
                type="text"
                inputMode="decimal"
                className="form-control"
                placeholder="Amount"
                name="amount"
                value={newItem.amount}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d*$/.test(value)) {
                    handleItemInputChange(e);
                  }
                }}
              />
            </div>

            <div className="col-md-1">
              {editingItemId === null ? (
                <button
                  className="btn btn-success btn-sm w-100 mt-4"
                  onClick={handleAddItem}
                >
                  <i className="bi bi-plus"></i>
                </button>
              ) : (
                <button
                  className="btn btn-info btn-sm w-100 mt-4"
                  onClick={handleUpdateItem}
                >
                  <i className="bi bi-check"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="container-fluid mt-2">
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="card card-body">
                  <h6>Item List</h6>
                  <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
                    <div className="table-container">
                      <table className="table table-layout-fixed w-100">
                        <thead className="bg-light">
                          <tr>
                            <th>S.No</th>
                            <th>Category</th>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Weight</th>
                            <th>Amount (₹)</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {updateData.loan_list.length > 0 ? (
                            updateData.loan_list.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{index + 1}</td>
                                <td>{item.category}</td>
                                <td>{item.product_name}</td>
                                <td>{item.quantity}</td>
                                <td>{item.weight}</td>
                                <td>{item.amount}</td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-warning me-1"
                                    onClick={() => handleEditItem(item)}
                                  >
                                    <i className="bi bi-pencil"></i>
                                  </button>
                                  <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => handleRemoveItem(item.id)}
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No items added yet
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-2">
                <div className="card card-body">
                  <h6>Payment List History</h6>
                  <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
                    <div className="table-container">
                      <table className="table table-layout-fixed w-100">
                        <thead className="bg-light">
                          <tr>
                            <th>S.No</th>
                            <th>Loan Id</th>
                            <th>Payment Date</th>
                            <th>Amount (₹)</th>
                            <th>Payment Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {updateData.loan_payment_history.length > 0 ? (
                            updateData.loan_payment_history.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{index + 1}</td>
                                <td>{item.loan_id}</td>
                                <td>{item.payment_date}</td>
                                <td>{item.amount}</td>
                                <td>{item.payment_type}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No payment history yet
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-5">
              <div className="card card-body">
                <div className="row mb-2">
                  <div className="col-md-6">
                    <label className="form-label">Loan Amount (₹)</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="loan_amount"
                      value={updateData.loan_amount}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <label className="form-label">Rate Of Interest (ROI)</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      inputMode="decimal"
                      className="form-control"
                      name="rate_of_interest"
                      value={updateData.rate_of_interest}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-md-6">
                        <label className="form-label">No Of Months</label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          className="form-control"
                          name="no_of_month"
                          value={updateData.no_of_month}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-md-6">
                        <label className="form-label">No Of Days</label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          className="form-control"
                          name="no_of_days"
                          value={updateData.no_of_days}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <label className="form-label">Rate Of Value (ROV)</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="rate_of_value"
                      value={updateData.rate_of_value}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <label className="form-label">Overall Total</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="overall_total"
                      value={updateData.overall_total}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <label className="form-label">Return Amount (₹)</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      inputMode="decimal"
                      className="form-control"
                      name="return_amount"
                      value={updateData.return_amount}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <label className="form-label">Notes</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="notes"
                      value={updateData.notes}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <label className="form-label">Loan Status</label>
                  </div>
                  <div className="col-md-6">
                    <select
                      className="form-select"
                      name="loan_status"
                      value={updateData.loan_status}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Loan Status</option>
                      <option value="Open">Open</option>
                      <option value="Close">Close</option>
                    </select>
                  </div>
                </div>

                {updateData.loan_status === "Close" && (
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label className="form-label">Loan Close Date</label>
                    </div>
                    <div className="col-md-6">
                      <input
                        type="date"
                        className="form-control"
                        name="loan_close_date"
                        value={updateData.loan_close_date}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                )}

                <div className="row">
                  <div className="col-lg-4">
                    <button
                      className="btn btn-secondary btn-sm w-100"
                      onClick={handleCancel}
                    >
                      <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                  </div>
                  <div className="col-lg-4">
                    <button
                      className="btn btn-primary btn-sm w-100"
                      onClick={handlePrint}
                    >
                      <i className="bi bi-printer"></i> Print
                    </button>
                  </div>
                  <div className="col-lg-4">
                    <button
                      className="btn btn-success btn-sm w-100"
                      onClick={handleLoanSubmit}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Update"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="printModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title text-primary" id="printModalLabel">
                Print (If You Want Print or Not?)
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="text-center">
                  <img
                    alt=""
                    className="border"
                    src={require("../../assets/images/Print_Demo.png")}
                    style={{ height: "300px" }}
                  ></img>
                </div>
                <div className="d-flex justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm mx-2"
                    onClick={() => navigate("/loan")}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handlePrint}
                  >
                    Print
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showCustomerModal ? "show" : ""}`}
        style={{
          display: showCustomerModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="addCustomerModalLabel"
        aria-hidden={!showCustomerModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="addCustomerModalLabel"
              >
                Add Customer
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeCustomerModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleCustomerSubmit}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="customerType" className="form-label">
                        Customer Type <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-control ${validationErrors.customer_type ? "is-invalid" : ""
                          }`}
                        id="customerType"
                        value={addCustomerData.customer_type}
                        onChange={handleCustomerTypeChange}
                        required
                      >
                        <option value="" disabled>
                          Select Customer Type
                        </option>
                        <option value="Walk-In">Walk-In</option>
                        <option value="Regular">Regular</option>
                        <option value="Retailer">Retailer</option>
                      </select>
                      {validationErrors.customer_type && (
                        <div className="invalid-feedback">
                          {validationErrors.customer_type}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="customerId" className="form-label">
                        Customer ID
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="customerId"
                        placeholder="Customer ID will be generated"
                        value={addCustomerData.customer_id}
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${validationErrors.name ? "is-invalid" : ""
                          }`}
                        id="name"
                        placeholder="Enter Name"
                        value={addCustomerData.name}
                        onChange={(e) =>
                          setAddCustomerData({
                            ...addCustomerData,
                            name: e.target.value,
                          })
                        }
                        required
                      />
                      {validationErrors.name && (
                        <div className="invalid-feedback">
                          {validationErrors.name}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="mobile" className="form-label">
                        Mobile Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="10"
                        className={`form-control ${validationErrors.mobile ? "is-invalid" : ""
                          }`}
                        id="mobile"
                        placeholder="Enter Mobile"
                        value={addCustomerData.mobile}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setAddCustomerData({
                              ...addCustomerData,
                              mobile: value,
                            });
                          }
                        }}
                        required
                      />
                      {validationErrors.mobile && (
                        <div className="invalid-feedback">
                          {validationErrors.mobile}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="address" className="form-label">
                    Address
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="address"
                    placeholder="Enter Address"
                    value={addCustomerData.address}
                    onChange={(e) =>
                      setAddCustomerData({
                        ...addCustomerData,
                        address: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="customerStatus" className="form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${validationErrors.status ? "is-invalid" : ""
                      }`}
                    id="status"
                    value={addCustomerData.status}
                    onChange={(e) =>
                      setAddCustomerData({
                        ...addCustomerData,
                        status: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  {validationErrors.status && (
                    <div className="invalid-feedback">
                      {validationErrors.status}
                    </div>
                  )}
                </div>
                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm px-4"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {showModal && <div className="modal-backdrop fade show"></div>}
      {showCustomerModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default UpdateLoan;